
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './AddressWizard.html?raw';
import on from 'dojo/on';
import { AddressWizardTypes, AddressWizardTypes as Types, AddressClassnames } from "./AddressWizardTypes";
// v v v soll einige Entitytypen langsam ablösen! Standardisierung hilft langfristig <3
import { AddressTypes as AddressEntityTypes, Classname as AddressClassname } from "../_loadingHelpers/Address";
import dojoQuery from 'dojo/query';

import _StatefulBase from '../../moreCore/UI/_StatefulBase/_StatefulBase';
import DateInput from '../../moreCore/UI/DateInput/DateInput';
import '../../moreCore/UI/DateInput/DateInput';
import Edit from '../../moreCore/UI/Edit/Edit';
import '../../moreCore/UI/Edit/Edit';
import SelectBox from '../../moreCore/UI/SelectBox/SelectBox';
import '../../moreCore/UI/SelectBox/SelectBox';
import HintBox from '../../moreCore/UI/EntityBased/HintBox/HintBox';
import '../../moreCore/UI/EntityBased/HintBox/HintBox';
import '../../moreCore/UI/PhoneInput/PhoneInput';
import FileUpload from '../../moreCore/UI/Filetransfer/FileUpload/FileUpload';
import '../../moreCore/UI/Filetransfer/FileUpload/FileUpload';
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import '../../moreCore/UI/GenericDialog/GenericDialog';
import CheckBox from '../../moreCore/UI/CheckBox/CheckBox';
import '../../moreCore/UI/CheckBox/CheckBox';
import Button from '../../moreCore/UI/Button/Button';
import '../../moreCore/UI/Button/Button';
import '../../moreCore/UI/DatePicker/DatePicker';
import '../../moreCore/UI/NumberInput/NumberInput';
import MultiSelectBox from '../../moreCore/UI/EntityBased/MultiselectBox/MultiselectBox';
import '../../moreCore/UI/EntityBased/MultiselectBox/MultiselectBox';
import ContactPersonForm from './ContactPersonForm/ContactPersonForm';
import _TabEnabledMixin from '../../moreCore/UI/Tabbing/_TabEnabledMixin';
import "../../moreCore/UI/Container/ExpandableSection";
import ExpandableSection from '../../moreCore/UI/Container/ExpandableSection';
import { HTMLElementWithExpander, ExpandableSectionMarkings } from "../../moreCore/UI/Container/ExpandableSectionTypes";
import FileUploadDisplay_ListRow from '../../moreCore/UI/Filetransfer/FileUpload/FileUploadDisplay_ListRow/FileUploadDisplay_ListRow';
import SearchSelect from '../../moreCore/UI/SearchSelect/SearchSelect';
import _LabelInputBase from '../../moreCore/UI/_LabelInputBase/_LabelInputBase';
import Tooltip from '../../moreCore/UI/Floating/Tooltip';
import DivisionsSection from './Divisions/DivisionsSection';
import EntityStore from '../../moreCore/Tools/EntityStore';
import StaticTable from '../../moreCore/UI/StaticTable/StaticTable';
import GenericEntityView from '../../moreCore/UI/EntityBased/EntityView/GenericEntityView';
import "../../moreCore/UI/Toaster_TS/ToasterTypes";
import { ExtraHelpers, FeatureHelpers, ToasterHelpers, TranslationHelpers } from "../../more/Helpers";

import contactDisplayTable from './ContactAndCommunication/contactDisplayTable';
import "./ContactAndCommunication/contactDisplayTable";
import communicationEditor from './ContactAndCommunication/communicationEditor';
import ExtendedPropertyList from '../PropertyList/ExtendedPropertyList';
import { ExtendedProperties } from "../PropertyList/ExtendedPropertyTypes";

import filePreview from '../filePreview/filePreview';
import TodoAppointmentsTable from '../TodoAppointments/TodoAppointmentsTable';
import { TodoAppointment } from "../TodoAppointments/TodoAppointmentsTypes";
import AddressDocumentsMain from './AddressDocuments/AddressDocumentsMain';
import RelatedAddressesSection from './RelatedAddresses/RelatedAddressesSection';
import { RelatedAddress } from "./RelatedAddresses/RelatedAddressTypes";
import FurtherAddressesMain from './FurtherAddresses/FurtherAddressesMain';
import GooglePlacesWidget from '../../moreCore/UI/GooglePlaces/GooglePlacesWidget';
import CommunicationPanel from './CommunicationPanel/CommunicationPanel';
import VCardGenerator from '../VCardGenerator/VCardGenerator';
import OrganizationContactPerson from './ContactPersonForm/Wizard/OrganizationContactPerson';
import GDPRSection from './GDPR/GDPRSection';
import PerformerSection from './Performer/PerformerSection';


interface TelecomReg {
    input: MdsLax<InstanceType<ReturnType<typeof _LabelInputBase>>>;
    node: HTMLElement;
    entityID?: any
    deleted?: boolean
}
class AddressWizard extends compose(_TabEnabledMixin) {
    templateString: any = template;

    private overrideSectionVisibilityConfig: Types.HideSelectedSectionsConfig = null;
    private expanderSection: MdsLax<InstanceType<typeof ExpandableSection>>;
    private formContainer: HTMLElement;
    private formHeading: HTMLHeadingElement;
    private inactiveAddressNoticeContainer: HTMLElement;
    private OrganizationContactPersonDataForm: HTMLElementWithExpander;
    //OrganizationContactPersonForm: ContactPersonForm;
    private sectionTelecom: HTMLElementWithExpander;
    private ContactPersonDataForm: HTMLElementWithExpander;
    private ContactPersonForm: MdsLax<InstanceType<typeof ContactPersonForm>>;
    private selectedAddressType: "person" | "company";

    //private newContactPersonButton: HTMLElement;
    private addContactPersonButton: HTMLElement;

    //selectAddressTypeButton: HTMLButtonElement;

    private addressTypeSelection: HTMLDivElement;
    private saveButtonContainer: HTMLDivElement;
    //addressType: RadioGroup;

    private GeneralCompanyDataForm: HTMLDivElement;
    private Edit_name2: HTMLDivElement;
    private Edit_name3: HTMLDivElement;
    private name1: MdsLax<InstanceType<typeof Edit>>;
    private name2: MdsLax<InstanceType<typeof Edit>>;
    private name3: MdsLax<InstanceType<typeof Edit>>;
    private note2: MdsLax<InstanceType<typeof Edit>>;
    private mainStreetCompany: MdsLax<InstanceType<typeof Edit>>;
    private mainPlzCompany: MdsLax<InstanceType<typeof HintBox>>;
    private mainCityCompany: MdsLax<InstanceType<typeof HintBox>>;
    private mainCountryCompany: MdsLax<InstanceType<typeof HintBox>>;
    //private activeCheckBox2: CheckBox;
    private canEditFinance: boolean = false;
    private sectionClasslevel: HTMLDivElement;
    private SearchSelect_classlevel: HTMLDivElement;
    private classlevel: MdsLax<InstanceType<typeof SearchSelect>>;

    private store_AddressCategories: MdsLax<InstanceType<typeof EntityStore<Types.AddressCategory>>>;

    private generalCompanyMandatoryFields: any = ["name1"];

    private GeneralPersonDataForm: HTMLDivElement;
    private professionalTitle: MdsLax<InstanceType<typeof SelectBox>>;
    private salutation: MdsLax<InstanceType<typeof SelectBox>>;
    private titlePrefix: MdsLax<InstanceType<typeof SelectBox>>;
    private language: MdsLax<InstanceType<typeof SelectBox>>;
    private languageSelectContainer: HTMLElement;
    private firstname: MdsLax<InstanceType<typeof Edit>>;
    private surname: MdsLax<InstanceType<typeof Edit>>;
    private titleSuffix: MdsLax<InstanceType<typeof SelectBox>>;
    private birthDate: MdsLax<InstanceType<typeof DateInput>>;
    private composerBirthDate_Date: MdsLax<InstanceType<typeof DateInput>>;
    private composerDiedDate_Date: MdsLax<InstanceType<typeof DateInput>>;
    private citizenship: MdsLax<InstanceType<typeof HintBox>>;
    private note: MdsLax<InstanceType<typeof Edit>>;
    private activeCheckBox: MdsLax<InstanceType<typeof CheckBox>>;
    //isMusicianCheckBox: CheckBox;
    private isComposerCheckBox: MdsLax<InstanceType<typeof CheckBox>>;
    private isPerformerCheckBox: MdsLax<InstanceType<typeof CheckBox>>;
    private isContactPersonCheckBox: MdsLax<InstanceType<typeof CheckBox>>;
    private mainStreetPerson: MdsLax<InstanceType<typeof Edit>>;
    private mainPlzPerson: MdsLax<InstanceType<typeof HintBox>>;
    private mainCityPerson: MdsLax<InstanceType<typeof HintBox>>;
    private mainCountryPerson: MdsLax<InstanceType<typeof HintBox>>;

    private extendedPropertySectionContainer: HTMLElement;
    private extendedPropertySection: MdsLax<InstanceType<typeof ExpandableSection>>;
    private extendedPropertyList: MdsLax<InstanceType<typeof ExtendedPropertyList<AddressWizardTypes.AddressEntity>>>;


    divisionsSectionContainer: MdsLax<InstanceType<typeof ExpandableSection>>;
    divisionsSection: MdsLax<InstanceType<typeof DivisionsSection>> = null;

    private communicationPanelContainer: HTMLElement;
    private communicationPanelExpander: MdsLax<InstanceType<typeof ExpandableSection>>;
    private communicationPanelWidgetContainer: HTMLElement;
    private communicationPanel: MdsLax<InstanceType<typeof CommunicationPanel>>;
    private _communicationPanelTimeoutHandler: any = null;

    private addPerformerBtnContainer:HTMLDivElement;
    private addPerformerBtn:HTMLButtonElement;
    generalPersonMandatoryFields: any = ["salutation", "surname"];
    musicianContractFormContiner: HTMLDivElement;
    ContactPersonFormContainer: HTMLDivElement;
    /*
    MusicianDataForm: HTMLDivElement;
    functionalSubGroup: SelectBox;
    seviceObligation: NumberInput;
    musicianContractType: HintBox;
    contractStartDate: DateInput;
    contractEndDate: DateInput;
    profession: HintBox;
    functionalSubGroupTable: HTMLTableElement;
    professionsTable: HTMLTableElement;
    addFunctionalSubGroupButton: HTMLButtonElement;
    addProfessionButton: HTMLButtonElement;
    */


    musicianMandatoryFields: any = ["musicianContractType", "contractStartDate"];

    ComposerDataForm: HTMLElementWithExpander;
    composerBirthDate: MdsLax<InstanceType<typeof Edit>>;
    composerDiedDate: MdsLax<InstanceType<typeof Edit>>;

    private _isDataLoading: boolean = false;

    private PerformerDataForm: HTMLElementWithExpander;
    private performerName: MdsLax<InstanceType<typeof Edit>>;
    private profession: MdsLax<InstanceType<typeof HintBox>>;
    private isMainProfession: MdsLax<InstanceType<typeof CheckBox>>;
    private performerTable: HTMLTableElement;
    private orgContactPersonTable: HTMLTableElement;

    private filesTable: HTMLTableElement;

    //ContactPersonDataForm: HTMLDivElement;
    private contactPersonTable: HTMLTableElement;
    private organisation: MdsLax<InstanceType<typeof HintBox>>;
    private jobTitle: MdsLax<InstanceType<typeof HintBox>>;

    private FinanceDataForm: HTMLElementWithExpander;
    private taxNr: MdsLax<InstanceType<typeof Edit>>;
    private vatNr: MdsLax<InstanceType<typeof Edit>>;
    private vatCheckText: HTMLSpanElement;
    private vatIcon: HTMLImageElement;
    private sectionVAT: HTMLElement;
    private btnVatCheck: HTMLButtonElement;
    private iban: MdsLax<InstanceType<typeof Edit>>;
    private Edit_Bank: HTMLElement;
    private inputBank: MdsLax<InstanceType<typeof HintBox>>;
    private bankAccountTable: HTMLTableElement;

    private Edit_BankRed: HTMLElement;
    private bankNumberRed: MdsLax<InstanceType<typeof Edit>>;
    private bankNameRed: MdsLax<InstanceType<typeof Edit>>;


    private googlePlaces: MdsLax<InstanceType<typeof GooglePlacesWidget>> = null;
    private NewOrganizationContactPersonButtonContainer: HTMLElement;

    //private AdditionalContactDataFieldsRight: HTMLDivElement;
    //private AdditionalContactDataFieldsLeft: HTMLDivElement;
    private contactDataFields: {
        "mobile": Array<TelecomReg>,
        "phone": Array<TelecomReg>,
        "messenger": Array<TelecomReg>,
        "webphone": Array<TelecomReg>,
        "fax": Array<TelecomReg>,
        "mail": Array<TelecomReg>,
        "web": Array<TelecomReg>
    } = {
            fax: [],
            mail: [],
            messenger: [],
            mobile: [],
            phone: [],
            webphone: [],
            web: []
        };
    private additionalContactFieldsCounter: number = 1;
    private addContactFieldButton: HTMLButtonElement;

    private AddressCategoryDataForm: HTMLElementWithExpander;
    private addressCategory: MdsLax<InstanceType<typeof MultiSelectBox>>;
    private addressCategoryTable: HTMLTableElement;

    private _data_SelectionValues: Array<SelectionValueEntity>; //`?????


    private AllCountriesData: Array<Country>;
    private preferredCountries: string[] = [];
    protected topCountries: Array<Country> = [];


    private caseEditingFields: Array<string> = ['firstName', 'surname'];
    private formData: Partial<Types.WizardData> = {};
    private mandatoryFields: any = [];
    private _isDirty = false;

    private FileDataForm: HTMLElementWithExpander;
    private expandingContentFileData: HTMLDivElement;
    private fileUpload: MdsLax<InstanceType<typeof FileUpload>>;
    private fileCategories: Array<{ ID: string, description: string }> = [];
    private newUploadFiles: any[] = [];

    private topMenuCreated: boolean = false;

    private _lastLoadedData: Types.GetDataResponse = null;
    private entity: Types.AddressEntity;
    private entityId: string = null;

    private addBankAccountButton:HTMLButtonElement;

    private sectionTodoAppointments: HTMLElement;
    private todoAppointmentsTable: MdsLax<InstanceType<typeof TodoAppointmentsTable>>;
    private todoAppointments: Array<TodoAppointment> = [];
    private todoAppointmentDiffData: any = null;

    private sectionRelatedAddresses: HTMLElement;
    private relatedAddressesSection: MdsLax<InstanceType<typeof RelatedAddressesSection>>;
    private relatedAddressesDiffData: any = null;

    //contact and communication zeug:
    private contactAndCommunicationWidgetContainer:HTMLDivElement;
    private contactAndCommunicationTable:MdsLax<InstanceType<typeof contactDisplayTable>>;

    //address-documents
    private sectionAddressDocuments: HTMLElementWithExpander;
    private addressDocumentsWidgetContainer: HTMLDivElement;
    private addressDocumentsWidget: MdsLax<InstanceType<typeof AddressDocumentsMain>>;
    private addressDocumentsChangedData: Object = null;
    private _addressDocumentsTimeoutHandler: any = null;

    //further addresses
    private sectionFurtherAddresses: HTMLElementWithExpander;
    private furtherAddressesWidgetContainer: HTMLDivElement;
    private furtherAddressesWidget: MdsLax<InstanceType<typeof FurtherAddressesMain>>;
    private furtherAddressesChangedData: Object = null;
    private _furtherAddressesTimeoutHandler: any = null;

    //GDPR
    private GDPRSectionExpander: HTMLElementWithExpander;
    private GDPRSectionWidgetContainer: HTMLDivElement;
    private GDPRSectionWidget: MdsLax<InstanceType<typeof GDPRSection>>;
    private GDPRSectionChangedData: Object = null;
    private _GDPRSectionTimeoutHandler: any = null;

    //PERFORMER SECTION
    private performerSectionContainer: MdsLax<InstanceType<typeof ExpandableSection>>;
    private performerSection: MdsLax<InstanceType<typeof PerformerSection>>;
    private performerSectionChangedData: Object = null;
    private _performerSectionTimeoutHandler: any = null;

    //ENTITY VIEW
    protected sectionEntityView_Top: HTMLElement;
    protected EntityViewContainer_Top: HTMLElement;
    protected sectionEntityView_MiddleTop: HTMLElement;
    protected EntityViewContainer_MiddleTop: HTMLElement;
    protected sectionEntityView_Bottom: HTMLElement;
    protected EntityViewContainer_Bottom: HTMLElement;


    //FILE UPLOAD

    private filePreviewWidget:MdsLax<InstanceType<typeof filePreview>>;
    private _onUploadFile(p1, p2, p3) {
        //console.log("params", p1, p2, p3, this.fileUpload)

        //this.addValue(this.fileUpload);
        this.setDirty(true);
        let newFilesArr = this.fileUpload.getValue();

        if (newFilesArr && this.fileUpload.validateInput()) {
            if (this.newUploadFiles.length === 0) {
                this.newUploadFiles = newFilesArr;
                this.newUploadFiles.forEach(file => {

                    this.addDefaultCategoryToFile(file);
                });

                this.formData["fileUpload"] = this.newUploadFiles;
                console.debug("fileUpload", this.formData["fileUpload"]);
                return;
            } else {

                newFilesArr.forEach(file => {

                    let guid = file.guid;
                    let fileNames = file.filenames
                    let existingFile = this.newUploadFiles.filter(x => x["guid"] === guid)[0];

                    if (!existingFile) {

                        this.addDefaultCategoryToFile(file);

                        this.newUploadFiles.push(file);
                    } else {

                        if (existingFile && existingFile["fileCategories"] && existingFile["fileCategories"].length > fileNames.length) {

                            let catToDelete = existingFile["filenames"].filter(x => fileNames.indexOf(x) === -1);

                            if (catToDelete) existingFile["fileCategories"].splice(existingFile["fileCategories"].indexOf(existingFile["fileCategories"].filter(x => x["fileName"] === catToDelete)[0]), 1);
                        }

                        if (!existingFile["fileCategories"] || existingFile["fileCategories"].length == 0) {

                            this.addDefaultCategoryToFile(existingFile);
                        }
                    }
                });

                this.formData["fileUpload"] = this.newUploadFiles;
            }

            //this.allValues["fileUpload"] = newFilesArr;
        } else {
            this.newUploadFiles = [];
            delete this.formData["fileUpload"];
        }

        this.checkSectionContents();
    }

    private addDefaultCategoryToFile(file: { guid: string, filenames: string[] }): void {

        file["fileCategories"] = [];
        file["filenames"].forEach(fileName => {

            file["fileCategories"].push({
                fileName: fileName,
                category: this.fileCategories[0].ID
            });
        });
    }

    private _setupEntityViews() {

        this.hideNode(this.sectionEntityView_Top);
        this.UiModder.domConstruct.empty(this.EntityViewContainer_Top);

        this.hideNode(this.sectionEntityView_MiddleTop);
        this.UiModder.domConstruct.empty(this.EntityViewContainer_MiddleTop);

        this.UiModder.domConstruct.empty(this.EntityViewContainer_Bottom);
        this.hideNode(this.sectionEntityView_Bottom);

        if (!this.entityId) return;

        if (this.hasFeature("Address/EntityViewInEditor_Top")) {

            let entityview = new GenericEntityView();

            entityview.setup(this.entityId,
                this.entity?.Classname,
                this.getDisplayName(),
                "gDisp_Firstname_Name",
                this.EntityViewContainer_Top,
                null,
                "AddressWizard_Top");

            entityview.hideIfEmpty(true, lang.hitch(this, this.hideNode, this.sectionEntityView_Top));

        }
        if (this.hasFeature("Address/EntityViewInEditor_MiddleTop")) {

            let entityview = new GenericEntityView();

            entityview.setup(this.entityId,
                this.entity?.Classname,
                this.getDisplayName(),
                "gDisp_Firstname_Name",
                this.EntityViewContainer_MiddleTop,
                null,
                "AddressWizard_MiddleTop");

            entityview.hideIfEmpty(true, lang.hitch(this, this.hideNode, this.sectionEntityView_MiddleTop));

        }
        if (this.hasFeature("Address/EntityViewInEditor_Bottom")) {
            this.hideNode(this.sectionEntityView_Bottom, false);

            let entityview = new GenericEntityView();

            entityview.setup(this.entityId,
                this.entity?.Classname,
                this.getDisplayName(),
                "gDisp_Firstname_Name",
                this.EntityViewContainer_Bottom,
                null,
                "AddressWizard_Bottom");

            entityview.hideIfEmpty(true, lang.hitch(this, this.hideNode, this.sectionEntityView_Bottom));

        }
    }

    protected setupSelectBoxInFileRow(evt: { name: string, row: MdsLax<InstanceType<typeof FileUploadDisplay_ListRow>> }): void {

        let fileRow = evt.row;
        console.debug("fileRow", fileRow);
        let selectBox = new SearchSelect();
        selectBox.setCyName("AddressWizard_fileCategory");

        selectBox.labelAttribute = "description";
        selectBox.setLabel(TranslationHelpers.tryTranslate("AddressWizard__fileCategory", false, "Kat."));
        selectBox.setSelectionListLEGACY(this.fileCategories);

        let categoryToSet = this.fileCategories[0].ID;

        this.formData["fileUpload"]?.forEach(file => {

            if (file["guid"] === fileRow.getData()["uploadGUID"]) {

                if (file["fileCategories"]) categoryToSet = file["fileCategories"].filter(x => x["fileName"] === fileRow.getData()["FileName"])[0]["category"];
            }
        });

        selectBox.setValue(categoryToSet, true);

        selectBox.on("change", lang.hitch(this, this.assingCategoryToNewFile, fileRow, selectBox.getValue()));

        fileRow.addContent_LEGACY(true, selectBox.domNode);
    }

    private assingCategoryToNewFile(fileRow: MdsLax<InstanceType<typeof FileUploadDisplay_ListRow>>, value: string): void {

        let rowFileGuid = fileRow.getData()["uploadGUID"];
        let rowFileName = fileRow.getData()["FileName"];
        let fileToSave = this.formData["fileUpload"].filter(x => x["guid"] === rowFileGuid)[0];

        //if (fileToSave) fileToSave["fileCategoryID"] = value;
        if (fileToSave) fileToSave["fileCategories"].filter(x => x["fileName"] === rowFileName)[0]["category"] = value;

        console.debug("fileUpload", this.formData["fileUpload"]);
    }

    //EVENTS

    private _onClick_SaveAndClose() {
        if (this.submitFormData() == true) {
            this.emit("close");
        }
    }

    private _onClick_ToggleActivate(evt) {
        this.activeCheckBox.setValue(!this.activeCheckBox.getValue());

    }

    loadAddress(entityID: string, temporaryLabel?: string) {
        this._onCreatePrivilege(false);

        this.addStartupStep("applyData");

        if (temporaryLabel) {
            this.setHeading(temporaryLabel);
        }
        this.StandbyStart();
        var url = window.appRoot + "AddressWizard/GetAddressById";
        this.hideNode(this.addressTypeSelection);
        this.hideNode(this.formContainer, false);
        this._tabContainer?.toggleVisibilityForActionBar(true);


        this.RequestManager.post(
            url,
            { jsonData: JSON.stringify({ id: entityID }) },
            lang.hitch(this, this._onGetAddressByIdResponse),
            lang.hitch(this, this._onGetAddressByIdError),
            false // sync
        );

    }

    private setHeading(title: string) {
        this.title = title;
        if (this.isEmbeddedInTab) {
            this.requestTabRename(title);
        }

        this.UiModder.domAttr.set(this.formHeading, "innerHTML", title);
        this.UiModder.domClass.toggle(this.formHeading, "w3-hide", !title);
    }

    private requestDeletion() {
        alert("requested deletion...");
    }

    private _rollback() {
        if (this.isDirty() && this._lastLoadedData) {
            this.contactAndCommunicationTable.updateData();

            this.applyData(this._lastLoadedData);

            if (this.hasFeature("Address/AddressDocumentsSection")) {
                this._loadAddressDocumentsSection();
            }
            if (this.hasFeature("Address/FurtherAddressesSection")) {
                this._loadFurtherAddressesSection();
            }
            if (this.hasFeature("Address/CommunicationPanel")) {
                this._loadCommunicationPanelSection();
            }
            if (this.hasUserRole("Addresses_GDPR")) {
                this._loadGDPRSection();
            }
            if (FeatureHelpers.hasModuleVersion("Address", 251201.0000)) {
                this._loadPerformerSection();
            }
        }
    }

    private _reload() {
        this.loadAddress(this.entityId);

        this.contactAndCommunicationTable.updateData();
    }

    private _onCreatePrivilege(hasPriv: boolean) {
        if (hasPriv) {
            this.createDefaultButton("save", lang.hitch(this, this._onClick_Save), false);
        } else {
            this.requestContextButtonRemove("save");
        }
    }

    private _onEditPrivilege(hasPriv: boolean) {
        if (hasPriv) {
            if (this._lastLoadedData != null) {
                this.createDefaultButton("rollback", lang.hitch(this, this._rollback), false);
                this.createDefaultButton("reload", lang.hitch(this, this._reload), true);
            }
            this.createDefaultButton("save", lang.hitch(this, this._onClick_Save), false);
        } else {
            this.disableNode(this.domNode);
        }
    }
    private _onDeletePrivilege(hasPriv: boolean) {
        if (hasPriv) {
            //this.createDefaultButton("delete", lang.hitch(this, this._onClick_Delete_Button));
            this.createDefaultButton(
                this.activeCheckBox.getValue() ? "deactivate" : "activate",
                lang.hitch(this, this._onClick_ToggleActivate),
                this.entityId != null
            );
        } else {
            this.requestContextButtonRemove("deactivate");
            this.requestContextButtonRemove("activate");
        }
    }

    private showNodeIfPrivilege(node: HTMLElement, hasPriv: boolean, privName: string) {
        if (!node) return;

        this.hideNode(node, !hasPriv);
    }

    applyData(data: Types.GetDataResponse) {


        this._lastLoadedData = data;
        this.entity = data.address;
        this.entityId = data?.address?.ID;

        let fakeEntity: more.EntityAPIResult = {
            Classname: AddressClassnames.vt_addresses,
            ID: this.entityId
        };

        this.addStartupStep("privileges");
        this.webPrivilegeManager.loadPrivilegesForEntity(this.entity ? fakeEntity : null, lang.hitch(this, this._onPrivilegesLoaded));
        this.emit("ready");
    }

    private _onPrivilegesLoaded() {


        if (this.entity) {
            let fakeEntity: more.EntityAPIResult = {
                Classname: AddressClassnames.vt_addresses,
                ID: this.entityId
            };
            this.hasUserRole(["Addresses_Delete", "Addresses_Edit"],
                lang.hitch(this, this._onDeletePrivilege),
                fakeEntity);

            this.hasUserRole(["Addresses_Edit"],
                lang.hitch(this, this._onEditPrivilege),
                fakeEntity);

            let canEditFinance = this.hasUserRole("Addresses_Finance_Edit", null, fakeEntity);
            this.canEditFinance = canEditFinance;
            if (canEditFinance == false) {
                this.addBankAccountButton.disabled = true;
                this.addBankAccountButton.classList.add("disabled");
                this.iban.setReadonly(true);
                this.inputBank.setReadonly(true);
            } else {
                this.addBankAccountButton.disabled = false;
                this.addBankAccountButton.classList.remove("disabled");
                this.iban.setReadonly(false);
                this.inputBank.setReadonly(false);
            }
        }
        this.continueApplyData();

        this.completeStartupStep("privileges");
    }

    private continueApplyData() {

        let data = this._lastLoadedData;

        //this.UiModder.domConstruct.empty(this.AdditionalContactDataFieldsRight);
        //this.UiModder.domConstruct.empty(this.AdditionalContactDataFieldsLeft);
        this.additionalContactFieldsCounter = 1; // reset to start
        // Registry zurücksetzen:
        this.contactDataFields = {
            fax: [],
            mail: [],
            messenger: [],
            mobile: [],
            phone: [],
            web: [],
            webphone: []
        }

        //if (this.isEmbeddedInTab && !this.topMenuCreated) {
        //    this.requestContextButton({
        //        callback: lang.hitch(this, this.requestDeletion),
        //        label: this.translate("General_Delete"],
        //        permanent: false,
        //        placement: "actionbar"
        //    });
        //
        //    this.topMenuCreated = true;
        //}




        let entity = this.entity;

        if (entity.Classname == "persons") {

            //this.addressType.setValue("person", true);
            this.selectedAddressType = "person";
            this.emit("change_selectedAddressType");
            this.startFormWithSelectedType();
            this.formData["ID"] = entity.ID;

            this.salutation.setValue(entity.persons___ref_salutation?.ID, false);
            this.professionalTitle.setValue(entity.persons___ref_professional_title?.ID)
            this.titlePrefix.setValue(entity.persons___ref_academic_title_prefix?.ID);
            this.titleSuffix.setValue(entity.persons___ref_academic_title_suffix?.ID);

            // Surname
            this.surname.setValue(entity.name);
            this._onValueChange_surname();

            // Firstname
            this.firstname.setValue(entity.persons___name_first);
            this._onValueChange_firstName();

            // Birthdate
            this.birthDate.setValue(entity.persons___day_of_birth);
            this._onValueChange_birthDate();

            //Classlevel
            this.classlevel.setValue(entity.ref_class_level);

            // ComposerBirth/Died
            this.composerBirthDate.setValue(entity.persons___born);
            this._onValueChange_composerBirthDateEdit();
            this.composerDiedDate.setValue(entity.persons___died);
            this._onValueChange_composerDiedDateEdit();

            this.composerBirthDate_Date.setValue(entity.persons___day_of_birth);
            this._onValueChange_composerBirthDate(entity.persons___day_of_birth);
            this.composerDiedDate_Date.setValue(entity.persons___day_of_death);
            this._onValueChange_composerDiedDate(entity.persons___day_of_death);

            this.citizenship.setValue(entity.persons___ref_citizenship);

            this.note.setValue(entity.note);
            this.activeCheckBox.setValue(entity.is_active);
            this.isComposerCheckBox.setValue(entity.persons___is_opus_address);
            this.isPerformerCheckBox.setValue(entity.is_perfomer);
            //this.mainStreetPerson.setValue(data["address"]["street"], false);
            this.mainStreetPerson.setValue(entity.street, false);
            this._onValueChange_mainStreetPerson();


            this.mainPlzPerson.setValue(entity.ref_postal_code);
            this.mainCityPerson.setValue(entity.ref_postal_code);

            if (this.hasFeature("address/plaintextCities") && !entity.ref_postal_code) {
                if (entity.c_postal_code) this.mainPlzPerson.setValue(entity.c_postal_code);
                if (entity.c_city) this.mainCityPerson.setValue(entity.c_city);
            }

            //this._onValueChange_mainPlzPerson(); // direkt aufrufen weil sonst kein onchange stattfindet und die allValues nicht beschrieben werden
            //this._onValueChange_mainCityPerson(); // direkt aufrufen weil sonst kein onchange stattfindet und die allValues nicht beschrieben werden

            this.mainCountryPerson.setValue(entity.ref_country);

            this.taxNr.setValue(data.address.tax_no);
            this.vatNr.setValue(data.address.VAT_no);

            if (data.contactPerson.length > 0) {
                this.isContactPersonCheckBox.setValue(true);
                data.contactPerson.forEach(lang.hitch(this, this._addContactPersonToTable))
            }

            if (data.associates.length > 0) {
                this.isContactPersonCheckBox.setValue(true);
                data.associates.forEach(lang.hitch(this, this._addAssociatesToTable))
            }
        } else if (entity.Classname == "organisations_external" || entity.Classname == "organisations_internal") {
            //this.addressType.setValue("company", true);
            this.selectedAddressType = "company";
            this.emit("change_selectedAddressType");
            this.startFormWithSelectedType();
            this.formData.ID = entity.ID;
            this.name1.setValue(entity.name);
            this.name2.setValue(entity.vt_organisations___name_2);
            this.name3.setValue(entity.vt_organisations___name_3);
            this.note2.setValue(entity.note);
            this.activeCheckBox.setValue(entity.is_active);
            this.isPerformerCheckBox.setValue(entity.is_perfomer);
            this.mainStreetCompany.setValue(entity.street, false);


            this.mainPlzCompany.setValue(entity.ref_postal_code);
            this.mainCityCompany.setValue(entity.ref_postal_code);

            if (this.hasFeature("address/plaintextCities") && !entity.ref_postal_code) {
                if (entity.c_postal_code) this.mainPlzCompany.setValue(entity.c_postal_code);
                if (entity.c_city) this.mainCityCompany.setValue(entity.c_city);
            }

            this.mainCountryCompany.setValue(entity.ref_country);

            let translatedLabel = this.translate(this.entity.Classname == "organisations_external" ? "AddressWizard__organizationContactPerson" : "AddressWizard__organizationAssociate");
            translatedLabel = this.createFontawesomeIcon("fas fa-user-tie", "&nbsp;&nbsp;").outerHTML + translatedLabel;
            this.OrganizationContactPersonDataForm.expander.setHeading(translatedLabel);
            this.taxNr.setValue(data.address.tax_no);
            this.vatNr.setValue(data.address.VAT_no);

            if (data.orgContactPersons?.length > 0) {
                this.UiModder.domConstruct.empty(this.orgContactPersonTable);
                data.orgContactPersons.forEach(lang.hitch(this, this._addOrgContactPerson))
            }

            this.setUpDivisionsSection();
        }
        else {
            alert("invalid data!");
            this.StandbyStop();
            this._lastLoadedData = null;
            return;
        }

        if (this.hasFeature("AddressWizard/LanguageSelect")) this.language.setValue(entity.ref_language?.ID);

        this.setVATCheckStyle();
        if (entity.EL_banking_accounts_address.length > 0) {
            entity.EL_banking_accounts_address.forEach(lang.hitch(this, this._addBankAccouts))
        }


        if (entity.EL_ht_address_adresscategory_address.length > 0) {
            let selected = [];
            for (let htCat of entity.EL_ht_address_adresscategory_address) {
                selected.push(htCat.ref_address_category);
            }

            this.store_AddressCategories.setup(selected, "ID");

            this.addressCategory.setValue(selected);
        }
        this.todoAppointments = data.todoAppointments;
        this.handleTodoAppoinmentsList();

        this.handleRelatedAddressesList();

        this.performerName.setValue(entity.pseudonym);
        if (entity.EL_performers_address.length > 0) {
            this.selectedAddressType == "company" ? this.isPerformerCheckBox.setValue(true) : this.isPerformerCheckBox.setValue(true);
            entity.EL_performers_address.forEach(lang.hitch(this, this._addPerformers));
        } else {

            this.UiModder.domConstruct.empty(this.performerTable);
            this.isPerformerCheckBox.setValue(false);
        }

        if (this.hasFeature("Address/AddressDocumentsSection")) {
            if (this._addressDocumentsTimeoutHandler) clearTimeout(this._addressDocumentsTimeoutHandler);
            this._loadAddressDocumentsSection();
        }
        if (this.hasFeature("Address/FurtherAddressesSection")) {
            if (this._furtherAddressesTimeoutHandler) clearTimeout(this._furtherAddressesTimeoutHandler);
            this._loadFurtherAddressesSection();
        }
        if (this.hasFeature("Address/CommunicationPanel")) {
            if (this._communicationPanelTimeoutHandler) clearTimeout(this._communicationPanelTimeoutHandler);
            this._loadCommunicationPanelSection();
        }
        if (this.hasUserRole("Addresses_GDPR")) {
            if (this._GDPRSectionTimeoutHandler) clearTimeout(this._GDPRSectionTimeoutHandler);
            this._loadGDPRSection();
        }
        if (FeatureHelpers.hasModuleVersion("Address", 251201.0000)) {
            if (this._performerSectionTimeoutHandler) clearTimeout(this._performerSectionTimeoutHandler);
            this._loadPerformerSection();
        }
        this._createFilesTable(data.address.EL_root_ht_files);

        this.setupExtendedPropertySection(this.entity?.extendedPropertyAssignments),

        this._setupEntityViews();


        //if (data.address.EL_root_ht_files.length > 0) {

        //    //data["address"]["EL_root_ht_files"].forEach(lang.hitch(this, this._addFiles));
        //    this._createFilesTable(data.address.EL_root_ht_files);
        //} else {

        //    this.UiModder.domConstruct.empty(this.filesTable);
        //}


        //this.UiModder.domClass.add(this.selectAddressTypeButton, "w3-hide");
        this.checkSectionContents();

        this.requestContextButtonEnable("vCard", this.entityId != null);
        this.completeStartupStep("applyData");

        if (this.overrideSectionVisibilityConfig !== null) this.applyOverrideSectionVisibility();
    }

    private _createFilesTable(data: Array<Types.HtFile>) {
        //console.debug("FILE DATA", data);
        this.fileUpload.resetFileUpload();

        if (data.length === 0) {
            this.UiModder.domConstruct.empty(this.filesTable);
            return;
        }

        let filesArr = [];

        this.formData["filesToDelete"] = [];

        data.forEach(file => {

            filesArr.push({
                type: "file",
                fileData: { ID: file["ref_vt_file"]["ID"], value: file["ref_vt_file"]["filename"] },
                fileCategory: file["ref_vt_file"]["ref_file_category"]["description"]
            });
        });

        this._createTable(this.filesTable, filesArr);
    }

    private _addPerformers(data: AddressWizardTypes.Performer) {
        let professionValue = { ID: data.ref_ev_profession?.ID, value: data.ref_ev_profession?.description };
        let isMainProfession = data.is_main_profession
        let artistNameValue = data.gDisp_1
        //let performerNameValue = data["ref_address"]["pseudonym"]

        if (!this.formData.performer) this.formData.performer = [];
        this.formData.performer.push({
            type: "performer",
            artistName: artistNameValue,
            profession: professionValue,
            isMainProfession: isMainProfession
        })

        this._createTable(this.performerTable, this.formData.performer);
    }

    //private _addAddressCategory(data) {
    //    if (data && data.ref_address_category) {
    //        let addressCategoryValue = { ID: data["ref_address_category"]["ID"], value: data["ref_address_category"]["description"] }
    //        if (this.allValues.addressCategory) {
    //            this.allValues.addressCategory.push({ type: "addressCategory", addressCategory: addressCategoryValue })
    //        } else {
    //            this.allValues.addressCategory = [{ type: "addressCategory", addressCategory: addressCategoryValue }]
    //        }
    //        this._createTable(this.addressCategoryTable, this.allValues.addressCategory);
    //    }
    //}



    _addBankAccouts(data) {
        let bankValue;

        if (this.hasFeature("Address/BankRedEntry")) {
            let number = data["c_banknumber"];
            let name = data["c_bankname"];
            bankValue = { number: number, name: name, value: number ? `${number} - ${name}` : name }
        } else {
            if (!data["ref_bank"]) {
                console.error(`_addBankAccouts: there is no bank data in JSON`, data);
                return;
            }
            bankValue = { ID: data["ref_bank"]["ID"], value: data["ref_bank"]["gDisp_1"] }
        }
        
        let ibanValue = data["IBAN"]
        if (this.formData["bankAccount"]) {
            this.formData["bankAccount"].push({ type: "bankAccount", bank: bankValue, iban: ibanValue })
        } else {
            this.formData["bankAccount"] = [{ type: "bankAccount", bank: bankValue, iban: ibanValue }]
        }
        this._createTable(this.bankAccountTable, this.formData["bankAccount"]);

    }

    private _openPersonFromTable(data: Types.OrgContactPersonListEntry) {

        let address: Types.Person = data.entity.ref_person;

        let addressID = address?.ID;
        if (!addressID) return;


        if (this.isEmbeddedInTab) {
            let wizard = new AddressWizard();

            this.requestNewTabbedContent({
                enableClosing: true,
                label: address.gDisp_1,
                widget: wizard,
                name: addressID,
                sidebarEntryName: addressID
            }, true);

            wizard.loadAddress(addressID, address.gDisp_1);
        }
    }

    private _addOrgContactPerson(entity: Types.OrganisationContactPersonEntity) {

        if (!this.formData.orgContactPersons) this.formData.orgContactPersons = [];
        this.formData.orgContactPersons.push({
            type: "orgContactPersons",
            //contactPersonType: this.translate("AddressWizard__organizationContactPerson"],
            person: entity.ref_person.gDisp_1,
            isMainOrganisation: entity["is_main_organisation"],
            addressType: entity.ref_address_types ? entity.ref_address_types.description : "",
            entity: entity
        })

        this._createTable(this.orgContactPersonTable, this.formData.orgContactPersons, this.isEmbeddedInTab ? lang.hitch(this, this._openPersonFromTable) : null);
    }

    private _addContactPersonToTable(entity: Types.ContactPersonEntity) {

        let organisationValue: Types.ValueStump = {
            ID: entity.ref_organisation.ID,
            value: entity.ref_organisation.gDisp_1,
            is_active: entity.ref_organisation.is_active
        };
        let jobTitleValue = { ID: entity["ref_job_title"] ? entity["ref_job_title"]["ID"] : null, value: entity["c_job_title"] };


        if (!this.formData.contactPerson) {
            this.formData.contactPerson = [];
        }

        this.formData.contactPerson.push({
            type: "contactPerson",
            /* = LABEL! */contactPersonType: this.entity?.Classname == AddressClassnames.organisations_internal ? this.translate("AddressWizard__Associate") : this.translate("AddressWizard__ContactPerson"),
            organisation: organisationValue,
            jobTitle: jobTitleValue,
            entity: entity
        })

        this._createTable(this.contactPersonTable, this.formData.contactPerson, lang.hitch(this, this._editContactPerson));
    }

    private _addAssociatesToTable(entity: Types.AssociateEntity) {
        let organisationValue = { ID: entity.ref_organisation.ID, value: entity.ref_organisation.gDisp_1 };
        let jobTitleValue = { ID: entity.ref_job_title ? entity.ref_job_title.ID : null, value: entity.c_job_title };


        if (!this.formData.contactPerson) {
            this.formData.contactPerson = [];
        }
        this.formData.contactPerson.push({
            type: "contactPerson",
            contactPersonType: this.translate("AddressWizard__Associate"),
            organisation: organisationValue,
            jobTitle: jobTitleValue,
            entity: entity
        });

        this._createTable(this.contactPersonTable, this.formData["contactPerson"], lang.hitch(this, this._editContactPerson));
    }

    private _onClick_Save(evt: MouseEvent): void {
        this.submitFormData();
    }

    submitFormData(): boolean {
        if (this.formData["contactPerson"]) {
            this.formData["contactPerson"].forEach(data => delete data["form"]);
        }

        let flag = true;

        for (let i = 0; i < this.mandatoryFields.length; i++) {
            this[this.mandatoryFields[i]].setMandatory(true);
            this[this.mandatoryFields[i]].validateInput()
            if (!this[this.mandatoryFields[i]].validateInput()) {
                flag = false
                this[this.mandatoryFields[i]]["domNode"].scrollIntoView({ behavior: "smooth", block: "center" });
            }
        }

        if (flag && this.formData) {
            this.formData = this.contactAndCommunicationTable.updateAddressWizzardState(this.formData as any); //holt daten aus kontakt table
            this._save();
            return flag;
        }
        this.showToast({
            title: this.translate("General_MandatoryMissing"),
            options: {
                ID: "mandatoryFields",
                //    timeout: 5000
            },
            iconClass: ToasterHelpers.ToasterIcons.error
        });
        return flag;
    }

    //_onChangeSelectAddressType() {
    //    this.selectedAddressType = <any>this.addressType.getValue();
    //}

    private _onClick_SelectAddressTypeOrganisation(evt: MouseEvent) {
        this.selectedAddressType = "company";
        this.emit("change_selectedAddressType");
        this.disableNode(this.NewOrganizationContactPersonButtonContainer);
        this.startFormWithSelectedType();
    }

    private _onClick_SelectAddressTypePerson(evt: MouseEvent) {
        this.selectedAddressType = "person";
        this.emit("change_selectedAddressType");
        this.startFormWithSelectedType();
    }

    private _currentContactPersonForm: MdsLax<InstanceType<typeof ContactPersonForm>>;

    private _editContactPerson(data: Types.ContactPersonListEntry, row: HTMLElement, evt) {
        if (this._currentContactPersonForm) {
            this._currentContactPersonForm.close();
        }

        this.UiModder.domConstruct.empty(this.ContactPersonFormContainer);
        //this.hideNode(this.ContactPersonFormContainer, false);
        //this.hideNode(this.newContactPersonButton);

        if (!data) {

        }

        console.debug("_editContactPerson", data);

        let form: MdsLax<InstanceType<typeof ContactPersonForm>> = null;
        if (data.form) {
            form = data.form;
        } else {
            form = new ContactPersonForm();
            form.setValues(data.entity);

            this.UiModder.domClass.add(form.domNode, "w3-margin-bottom");
        }

        var heading = this.entity ? this.entity.gDisp_Firstname_Name : this.translate("General_Label_NewAddress");

        //if (data.entity) {
        //    if (data.entity.gDisp_1) {
        //        heading = data.entity.gDisp_1;
        //    } else if (data.data) {
        //        if (data.data.contactPersonType) heading = data.data.contactPersonType;
        //    } else if (data.entity.$Displayname) {
        //        heading = data.entity.$Displayname;
        //    }
        //}

        let dlg = new GenericDialog();
        dlg.show(
            form,
            heading,
            null, null,
            data.form ? "ok" : "okcancel",
            lang.hitch(this, this._onContactPersonDlgCallback, data, row)
        );

        //data.form = form;

        form.startup();

        //on(form, "close", lang.hitch(this, this._onContactPersonFormCallback, data, false, row));
        //form.callback = lang.hitch(this, this._onContactPersonFormCallback, data, true, row);
        this._currentContactPersonForm = form;
        //form.placeAt(this.ContactPersonFormContainer);


        //this.UiModder.domClass.add(row, "pL3");

        /* mit Floating: */
        //this.UiModder.domClass.add(data.form.domNode, "padding");
        //let floating = new FloatingContainer();
        //on(floating, "close", lang.hitch(this, this._onContactPersonFormCallback, data, false));
        //floating.open(evt, data.form.domNode, true, true);

    }

    private _onContactPersonDlgCallback(originData: Types.ContactPersonListEntry, row: HTMLElement, result: number) {
        let formData: any = null;

        this.UiModder.domConstruct.place(this._currentContactPersonForm.domNode, this.ContactPersonFormContainer);
        //this.hideNode(this.newContactPersonButton, false);


        if (result <= 0) {
            return;
        }

        if (this._currentContactPersonForm && result >= 1) {
            formData = this._currentContactPersonForm.getValues();

            if (!originData) {
                originData = {
                    jobTitle: {
                        ID: null,
                        value: ""
                    },
                    organisation: {
                        ID: null,
                        value: ""
                    }
                };

                if (!this.formData.contactPerson) {
                    this.formData.contactPerson = [];
                }

                this.formData.contactPerson.push(originData);
            }

            originData.form = this._currentContactPersonForm;

            this.setDirty(true);
        }

        this._currentContactPersonForm = null;

        this._handleNewContactPersonData(originData, formData != null, row, formData);
    }

    private _handleNewContactPersonData(originData: Types.ContactPersonListEntry, bDoSave: boolean = true, row: HTMLElement, newData: Types.ContactPersonFormData) {
        //console.debug("_handleNewContactPersonData START", originData, newData);

        this.hideNode(this.ContactPersonFormContainer);
        //if (row) {
        //    this.UiModder.domClass.remove(row, "pL3");
        //}

        if (bDoSave === false) {

            return;
        }

        let jobTitleValue: Types.ValueStump = { ID: "", value: "" }
        let organisationValue: Types.ValueStump = { ID: "", value: "" };
        let typeLabel: string = this.translate("AddressWizard__ContactPerson");

        // Jobtitel und Organisation gleich auf die richtigen Daten draufschmeißen, damit die Tabelle sich richtig zeichnen kann
        if (newData.jobTitle && typeof newData?.jobTitle == "object") {
            jobTitleValue = { ID: newData.jobTitle.ID, value: newData.jobTitle.description }
        } else {
            jobTitleValue = { ID: null, value: newData.c_job_title }
        }
        if (typeof (newData.organisation) == "object") {
            organisationValue = { ID: newData.organisation.ID, value: newData.organisation.gDisp_1 }

            newData.organisation.Classname == AddressClassnames.organisations_internal ? typeLabel = this.translate("AddressWizard__Associate") : typeLabel;
        }



        originData.data = newData;

        originData.jobTitle = jobTitleValue;
        originData.organisation = organisationValue;
        originData.type = newData.type;
        originData.contactPersonType = typeLabel; // newData.contactPersonType;
        //originData.ID = originData.entity?.ID; //

        console.debug("_handleNewContactPersonData END", originData, newData, this.formData.contactPerson, originData.data.ID);

        this._createTable(this.contactPersonTable, this.formData.contactPerson, lang.hitch(this, this._editContactPerson));
        this.UiModder.domConstruct.empty(this.ContactPersonFormContainer);
    }

    private _onClick_Continue_Button() {
        this.startFormWithSelectedType();
    }

    setup(entityIDorFormType: string | "person" | "organisation") {
        if (entityIDorFormType == "person") {
            this.selectedAddressType = "person";
            this.emit("change_selectedAddressType");
            this.startFormWithSelectedType();
        } else if (entityIDorFormType == "organisation") {
            this.selectedAddressType = "company";
            this.emit("change_selectedAddressType");
            this.startFormWithSelectedType();
        } else if (!!entityIDorFormType) {
            this.loadAddress(entityIDorFormType);
        }
    }

    private startFormWithSelectedType() {
        this.hasUserRole("Addresses_Create", lang.hitch(this, this._onCreatePrivilege));

        let addressType = this.selectedAddressType;// this.addressType.getValue();
        this.hideNode(this.formContainer, false);

        if (this.hasFeature("Address/AddressDocumentsSection")) {
            this._addressDocumentsTimeoutHandler = setTimeout(lang.hitch(this, this._loadAddressDocumentsSection), 2000);
        }
        if (this.hasFeature("Address/FurtherAddressesSection")) {
            this._furtherAddressesTimeoutHandler = setTimeout(lang.hitch(this, this._loadFurtherAddressesSection), 2000);
        }
        if (this.hasFeature("Address/CommunicationPanel")) {
            this._communicationPanelTimeoutHandler = setTimeout(lang.hitch(this, this._loadCommunicationPanelSection), 2000);
        }
        if (this.hasUserRole("Addresses_GDPR")) {
            this._GDPRSectionTimeoutHandler = setTimeout(lang.hitch(this, this._loadGDPRSection), 2000);
        }
        if (FeatureHelpers.hasModuleVersion("Address", 251201.0000)) {
            this._performerSectionTimeoutHandler = setTimeout(lang.hitch(this, this._loadPerformerSection), 2000);
        }

        if (addressType) {
            this.formData = {};
            this.mandatoryFields = [];

            let sectionTelecomHeading = "AddressWizard__ContactData";
            switch (this.selectedAddressType) {
                case "person":
                    if (this._lastLoadedData == null) {
                        this.requestTabRename(this.title + " - " + this.translate("Addresses__Person"));
                    } else if (this._lastLoadedData.address.gDisp_Firstname_Name) {
                        this.setHeading(this._lastLoadedData.address.gDisp_Firstname_Name);
                    }

                    // Gehört bei Personen ausgeblendet:
                    this.hideNode(this.GeneralCompanyDataForm);
                    this.hideNode(this.OrganizationContactPersonDataForm.expander.domNode);


                    // Gehört bei Personen eingeblendet:
                    this.hideNode(this.GeneralPersonDataForm, false);
                    this.hideNode(this.sectionTelecom.expander.domNode, false);
                    this.hideNode(this.ContactPersonDataForm.expander.domNode, false);
                    this.hideNode(this.ComposerDataForm.expander.domNode, false);
                    this.hideNode(this.FileDataForm.expander.domNode, false);


                    this.mandatoryFields = this.mandatoryFields.concat(this.generalPersonMandatoryFields);

                    // Vorgabewert aktiv:
                    this.activeCheckBox.setValue(true, false);


                    break;
                case "company":
                    if (this._lastLoadedData == null) {
                        this.requestTabRename(this.title + " - " + this.translate("Addresses__Organisation"));
                    } else if (this._lastLoadedData.address.gDisp_Firstname_Name) {
                        this.setHeading(this._lastLoadedData.address.gDisp_Firstname_Name);
                    }
                    // gehört bei Organisation ausgeblendet:
                    this.hideNode(this.GeneralPersonDataForm);
                    this.hideNode(this.sectionTelecom.expander.domNode);
                    this.hideNode(this.ComposerDataForm.expander.domNode);


                    // gehört bei Organisation eingeblendet:
                    this.hideNode(this.GeneralCompanyDataForm, false);
                    this.hideNode(this.FileDataForm.expander.domNode, false);
                    this.hasUserRole("AddressWizard_OrganizationContactPersonData",
                        lang.hitch(this, this.showNodeIfPrivilege, this.OrganizationContactPersonDataForm.expander.domNode),
                        this.entity);


                    this.mandatoryFields = this.mandatoryFields.concat(this.generalCompanyMandatoryFields);

                    // Vorgabewert aktiv:
                    this.activeCheckBox.setValue(true, false);

                    if (this.canTranslate("AddressWizard__ContactData_orga")) sectionTelecomHeading = "AddressWizard__ContactData_orga";

                    break;

                default:
                    alert("invalid address type!");
                    return;
                    break;
                    break; 
            }
            this.sectionTelecom.expander.setHeading(`<i class="fas fa-phone">&nbsp;</i> ${this.translations[sectionTelecomHeading]}`);

            this.hasUserRole("AddressWizard_FinanceData", lang.hitch(this, this.showNodeIfPrivilege, this.FinanceDataForm.expander.domNode), this.entity);
            if (this.selectedAddressType === "person" && this.hasFeature("Address/AddressDocumentsSection")) this.hasUserRole("Address_AddressDocuments_Main", lang.hitch(this, this.showNodeIfPrivilege, this.sectionAddressDocuments.expander.domNode), this.entity);
            this.hasUserRole("AddressWizard_FurtherAddressesData", lang.hitch(this, this.showNodeIfPrivilege, this.sectionFurtherAddresses.expander.domNode), this.entity);
            this.hasUserRole("Addresses_GDPR", lang.hitch(this, this.showNodeIfPrivilege, this.GDPRSectionExpander.expander.domNode), this.entity);
            this.hasUserRole("AddressWizard_ContactData", lang.hitch(this, this.showNodeIfPrivilege, this.sectionTelecom.expander.domNode), this.entity);
            this.hasUserRole("AddressWizard_CategoryData", lang.hitch(this, this.showNodeIfPrivilege, this.AddressCategoryDataForm.expander.domNode), this.entity);

            //this.hideNode(this.FinanceDataForm.expander.domNode, !this.hasUserRole("AddressWizard_FinanceData"));
            //this.hideNode(this.LocationDataForm.expander.domNode, !this.hasUserRole("AddressWizard_LocationData"));
            //this.hideNode(this.sectionTelecom.expander.domNode, !this.hasUserRole("AddressWizard_ContactData"));
            //this.hideNode(this.AddressCategoryDataForm.expander.domNode, !this.hasUserRole("AddressWizard_CategoryData"));

            //this.addValue(this.addressType)
            if (!FeatureHelpers.hasModuleVersion("Address", 251201.0000)) this.hideNode(this.PerformerDataForm.expander.domNode, false);
            this.hideNode(this.addressTypeSelection);
            this._tabContainer?.toggleVisibilityForActionBar(true);
            //this.UiModder.domClass.remove(this.selectAddressTypeButton, "w3-hide");
            //this.hideNode(this.saveButtonContainer, false);

            this.formData.addressType = this.selectedAddressType;

            this.StandbyStop();
        }


        //this.toaster.addToast("Speichern", toasterIcons.save, { onClick: { callback: lang.hitch(this, this._onClick_Validate_Button) }, timeout: "permanent", close: false, ID: "save" })
    }

    private handleRelatedAddressesList(): void {
        if (!this.hasUserRole("Address_RelatedAddresses") || !this.hasFeature("Address/RelatedAddresses")) {
            this.UiModder.domConstruct.destroy(this.sectionRelatedAddresses);
            return;
        }

        if (this.relatedAddressesSection) {
            this.relatedAddressesSection.destroy();
            this.relatedAddressesSection = null;
        }

        this.relatedAddressesSection = new RelatedAddressesSection();
        this.relatedAddressesSection.setup(this.entity as any);
        this.relatedAddressesSection.on("change", lang.hitch(this, this._onChangeRelatedAddressesSection));
        this.relatedAddressesSection.on("reloaded", lang.hitch(this, this._onReloadRelatedAddressesSection));

        this.relatedAddressesSection.placeAt(this.sectionRelatedAddresses);

        this.hideNode(this.sectionRelatedAddresses, false);
    }

    private _onChangeRelatedAddressesSection(diffData: EntityStoreData<RelatedAddress>): void {
        this.relatedAddressesDiffData = diffData;
        this.formData.relatedAddressDiffData = diffData;
        this.setDirty(true);
    }

    private _onReloadRelatedAddressesSection(): void {
        this.relatedAddressesDiffData = null;
    }

    private handleTodoAppoinmentsList(): void {
        if (!this.hasUserRole("Address_TodoAppointments") || !this.hasFeature("Address/TodoAppointments")) {
            this.UiModder.domConstruct.destroy(this.sectionTodoAppointments);
        }

        if (this.todoAppointmentsTable) {
            this.todoAppointmentsTable.destroy();
            this.todoAppointmentsTable = null;
        }

        this.todoAppointmentsTable = new TodoAppointmentsTable();
        this.todoAppointmentsTable.setData(this.todoAppointments, this.entity as any);
        this.todoAppointmentsTable.on("change", lang.hitch(this, this._onChangeTodoAppointmentTable));
        this.todoAppointmentsTable.on("reloaded", lang.hitch(this, this._onReloadTodoAppointmentTable));

        this.todoAppointmentsTable.placeAt(this.sectionTodoAppointments);

        this.hideNode(this.sectionTodoAppointments, false);
    }

    private _onChangeTodoAppointmentTable(diffData: EntityStoreData<TodoAppointment>): void {
        this.todoAppointmentDiffData = diffData;
        this.formData.todoDiffData = diffData;
        this.setDirty(true);
    }

    private _onReloadTodoAppointmentTable(): void {
        this.todoAppointmentDiffData = null;
    }

    //private getExpandableSectionByNode(containerNode: HTMLElementWithExpander) {
    //    for (let entry of this._expandableNodes) {
    //        if (entry.targetNode == containerNode) {
    //            return entry;
    //        }
    //    }

    //    return null;
    //}
    //private toggleExpanderByNode(containerNode: HTMLElementWithExpander, bCollapse?: boolean) {
    //    let entry = this.getExpandableSectionByNode(containerNode);
    //    if (entry) entry.expanderWidget.toggleExpand(bCollapse);
    //}
    private _onClick_NewOrganizationContactPerson() {
        if (this.entity.Classname != "organisations_external" && this.entity.Classname != "organisations_internal") return;

        let titleTr = "General_New";
        if (this.entity.Classname == "organisations_external") titleTr = "AddressWizard_ContactPerson_NewContactPerson";
        if (this.entity.Classname == "organisations_internal") titleTr = "AddressWizard_ContactPerson_NewEmployee";

        let form = new OrganizationContactPerson(this.entity);
        form.show("dlg", this.translate(titleTr));

        form.on("saved", (entity) => {
            this._addOrgContactPerson(entity);
        });
    }
    private _onClick_AddBankAccount_Button() {
        let bankValue;
        let bankIsValid;

        if (this.hasFeature("Address/BankRedEntry")) {
            let number = this.bankNumberRed.getValue();
            let name = this.bankNameRed.getValue();
            bankValue = { number: number, name: name, value: number ? `${number} - ${name}` : name }

            bankIsValid = this.bankNameRed.validateInput();
        } else {
            if (typeof this.inputBank.getValue() == "object" && this.inputBank.getValue()) {
                bankValue = { ID: this.inputBank.getValue()["ID"], value: this.inputBank.getValue()["gDisp_1"] }
            } else {
                bankValue = { ID: null, value: this.inputBank.getValue() }
            }

            bankIsValid = this.inputBank.validateInput();
        }
        
        let ibanValue = this.iban.getValue();
        let ibanIsValid = this.iban.validateInput();


        if (bankIsValid && ibanIsValid && bankValue && ibanValue) {
            if (this.formData["bankAccount"]) {
                this.formData["bankAccount"].push({ type: "bankAccount", bank: bankValue, iban: ibanValue })
            } else {
                this.formData["bankAccount"] = [{ type: "bankAccount", bank: bankValue, iban: ibanValue }]
            }
            this._createTable(this.bankAccountTable, this.formData["bankAccount"]);
            this.inputBank.setValue(null);
            this.iban.setValue(null);

            this.bankNumberRed.setValue(null);
            this.bankNameRed.setValue(null);
        }
    }

    private _onClick_AddPerformer_Button() {
        this.addPerformerBtn.disabled = true;
        let performerName: string = this.performerName.getValue();

        if (!this.profession.getValue()) return;

        if (!performerName) {
            // wenn Organisation:
            if (this.selectedAddressType == "company") {
                performerName = this.name1.getValue();
            }
            // bei Person:
            else {
                performerName = this.firstname.getValue() + " " + this.surname.getValue();
            }


        }

        if (performerName) {
            performerName = performerName.trim();
            performerName += " - "
        }

        let artistNameValue = performerName + this.profession.getValue()["description"];
        let isMainProfession = !this.formData?.performer?.length;
        let professionValue;
        let professionIsValid = this.profession.validateInput();
        //let performerNameIsValid = this.performerName.validateInput();

        let profession = this.profession.getValue();
        if (!this.formData.performer) this.formData.performer = [];

        for (let performer of this.formData.performer) {
            if (performer["profession"].value === profession.description) {
                this.profession.setValue(null, true);
                this.showToast(this.translate("AddressWizard_Error_AddProfession"), "fas fa-exclamation-triangle");
                return;
            }
        }

        if (typeof this.profession.getValue() == "object" && this.profession.getValue()) {
            professionValue = {
                ID: this.profession.getValue()["ID"],
                value: this.profession.getValue()["description"]
            }
        } else {
            professionValue = {
                ID: null,
                value: this.profession.getValue()
            }
        }

        if (isMainProfession == true && this.formData.performer?.filter(p => p.isMainProfession == true).length > 0) {

            this.formData.performer.filter(p => p.isMainProfession == true).forEach(x => x.isMainProfession = false);
        }

        if (professionIsValid && professionValue /*&& performerNameIsValid && performerNameValue*/) {
            this.formData.performer.push({
                type: "performer",
                artistName: artistNameValue,
                profession: professionValue,
                isMainProfession: isMainProfession
            })

            this._createTable(this.performerTable, this.formData.performer);
            //this.performerName.setValue(null);
            this.profession.setValue(null);
        }
        this.isMainProfession.setValue(false, true);
    }

    private _onLoaded_AddressCategories() {
        this._onChange_AddressCategory();
        this.completeStartupStep("categories");
    }
    private _onClick_AddAddressCategory_Button(evt) {
        this._onChange_AddressCategory();
    }
    private _onChange_AddressCategoryStore(entities: Array<AddressWizardTypes.AddressCategory>) {
        let list = this.store_AddressCategories.getCurrentCompleteList();
        let diff = this.store_AddressCategories.getDiffData();

        this.addressCategory.setValue(list, true);

        this.formData.addressCategories = {
            added: diff.new,
            removed: diff.deleted,
            list: list
        };

        let tableList: Array<Types.AddressCategoryAssignment_Stump> = [];
        for (let cat of entities) {
            tableList.push({
                addressCategory: {
                    ID: cat.ID,
                    value: cat.description
                },
                type: "addressCategory"
            });
        }

        //console.debug("_onChange_AddressCategoryStore", tableList, list, this.formData.addressCategories);

        this.UiModder.domConstruct.empty(this.addressCategoryTable);
        this._createTable(this.addressCategoryTable, tableList);

        this.setDirty(true);
    }
    private _onChange_AddressCategory() {
        let selectedValues = this.addressCategory.getValue();
        let entities: Array<AddressWizardTypes.AddressCategory> = this.addressCategory.getValue(true);
        //console.debug("_onChange_AddressCategory", selectedValues, entities);

        this.store_AddressCategories.updateFromList(entities, true);
    }

    private _updateAddressCategoryFromFormData() {
        let currentValues = this.formData["addressCategory"].map(data => data["addressCategory"]["ID"]);
        this.addressCategory.setValue(currentValues);
    }

    private setVATCheckStyle() {
        this.UiModder.domClass.remove(this.vatIcon, "fa-question fa-check fa-exclamation");

        let currentValue = this.vatNr.getValue();

        let bActuallyValid = !!this.entity?.VAT_no_checked_at && currentValue == this.entity?.VAT_no && this.entity?.is_VAT_No_valid == true;
        let unknown = !this.entity?.VAT_no_checked_at || this.vatNr.getValue() != this.entity?.VAT_no;

        this.disableNode(this.btnVatCheck, !this.entityId || !currentValue);

        if (bActuallyValid == true) {
            this.UiModder.domClass.add(this.vatIcon, "fa-check");
            this.UiModder.domAttr.set(this.vatCheckText, "innerHTML", TranslationHelpers.tryTranslate("AddressWizard__checkedVatNr"));
        } else if (unknown == true) {
            this.UiModder.domClass.add(this.vatIcon, "fa-question");
            this.UiModder.domAttr.set(this.vatCheckText, "innerHTML", TranslationHelpers.tryTranslate("AddressWizard__uncheckedVatNr"));
        }
        else {

            this.UiModder.domClass.add(this.vatIcon, "fa-exclamation");
            this.UiModder.domAttr.set(this.vatCheckText, "innerHTML", TranslationHelpers.tryTranslate("AddressWizard__invalidVatNr"));
        }
    }


    private _onValueChange_name1() {
        this.addValueFromInput(this.name1);

        if (this.getDisplayName() && this.isEmbeddedInTab) {
            this.setTitles(this.getDisplayName());
        }
    }
    private _onValueChange_name2() {
        this.addValueFromInput(this.name2);

        if (this.getDisplayName() && this.isEmbeddedInTab) {
            this.setTitles(this.getDisplayName());
        }
    }
    private _onValueChange_name3() {
        this.addValueFromInput(this.name3);

        if (this.getDisplayName() && this.isEmbeddedInTab) {
            this.setTitles(this.getDisplayName());
        }
    }

    private _onValueChange_mainStreetCompany() {
        this.addValueFromInput(this.mainStreetCompany)
    }

    private _onValueChange_mainPlzCompany() {
        this.addValueFromInput(this.mainPlzCompany)
        var plz = this.mainPlzCompany.getValue() as AddressEntityTypes.PostalCode;
        if (plz && typeof plz == "object") {
            this.mainCityCompany.setValue(plz);
            this.mainCountryCompany.setValue(plz["ref_country"])
        }
    }

    private _onValueChange_mainCityCompany() {
        this.addValueFromInput(this.mainCityCompany)
        var city = this.mainCityCompany.getValue() as AddressEntityTypes.PostalCode;
        if (city && typeof city == "object") {
            this.mainPlzCompany.setValue(city);
            this.mainCountryCompany.setValue(city["ref_country"])
        }

        this.mainCountryCompany.setReadonly(city && typeof (city) == "object");
    }

    private _onValueChange_mainStateCompany() {
        this.addValueFromInput(this.mainCountryCompany);
        let country = this.mainCountryCompany.getValue();
        //console.debug("_onValueChange_mainStateCompany", this.entityId, country)

        if (country && this.entityId) {

            this.contactAndCommunicationTable.setAddressContext(this.entityId, country);
        } else if (country) {

            this.contactAndCommunicationTable.updateCountry(country);
        }
    }

    private _onValueChange_salutation() {
        this.addValueFromInput(this.salutation);
    }

    private _onValueChange_professionalTitle() {
        this.addValueFromInput(this.professionalTitle);
    }

    private _onValueChange_titlePrefix() {
        this.addValueFromInput(this.titlePrefix);
    }

    private _onValueChange_language() {
        this.addValueFromInput(this.language);
    }

    private _onValueChange_firstName() {
        this.addValueFromInput(this.firstname);

        if (this.getDisplayName() && this.isEmbeddedInTab) {
            this.setTitles(this.getDisplayName());
        }
    }

    private _onValueChange_surname() {
        this.addValueFromInput(this.surname);

        if (this.getDisplayName() && this.isEmbeddedInTab) {
            this.setTitles(this.getDisplayName());
        }
    }

    private _onValueChange_classlevel() {
        this.addValueFromInput(this.classlevel);
    }

    private _onValueChange_titleSuffix() {
        this.addValueFromInput(this.titleSuffix);
    }

    private _onValueChange_activeCheckBox() {
        this.addValueFromInput(this.activeCheckBox);

        this.hideNode(this.inactiveAddressNoticeContainer, this.activeCheckBox.getValue())
        this.disableNode(this.formHeading, !this.activeCheckBox.getValue());
        this.UiModder.domClass.toggle(this.formContainer, "secondaryTXT", !this.activeCheckBox.getValue());

        this.hasUserRole(["Addresses_Delete", "Addresses_Edit"],
            lang.hitch(this, this._onDeletePrivilege),
            this.entity);
    }


    private _onValueChange_birthDate() {
        this.addValueFromInput(this.birthDate);
        this.composerBirthDate_Date.setValue(this.birthDate.getValue());
    }

    private _onValueChange_citizenship() {
        this.addValueFromInput(this.citizenship);
    }

    private _onValueChange_note() {
        this.addValueFromInput(this.note);
    }

    private _onValueChange_note2() {
        this.addValueFromInput(this.note2);
    }

    private _onValueChange_taxNr() {
        this.addValueFromInput(this.taxNr);
    }

    private _onValueChange_vatNr() {
        this.setVATCheckStyle();
        if (this.vatNr.getValue() != this.entity?.VAT_no) {

        }
        this.addValueFromInput(this.vatNr);
    }

    private _onValueChange_iban() {
        this.addValueFromInput(this.iban)
    }

    private _onValueChange_mainStreetPerson() {
        this.addValueFromInput(this.mainStreetPerson)
    }

    private _onValueChange_mainPlzPerson() {
        this.addValueFromInput(this.mainPlzPerson)
        var plz = this.mainPlzPerson.getValue();
        if (plz && typeof plz == "object") {
            this.mainCityPerson.setValue(plz);
            this.mainCountryPerson.setValue(plz["ref_country"])
        }

        //console.log("_onValueChange_mainPlzPerson", this.allValues["mainCityPerson"]);
    }

    private _onValueChange_mainCityPerson() {
        this.addValueFromInput(this.mainCityPerson)
        var city = this.mainCityPerson.getValue();
        if (city && typeof city == "object") {
            this.mainPlzPerson.setValue(city);
            this.mainCountryPerson.setValue(city["ref_country"])
        }

        this.mainCountryPerson.setReadonly(city && typeof (city) == "object");

        //console.log("_onValueChange_mainCityPerson", this.allValues["mainCityPerson"]);

        /**
            plz/ort in evis leer, dann im web olz/ort eintragen -> speichern -> in gleichem formular staatsbürgerschaft eintragen und speichern.. dann ist plz leer

         * */
    }

    private _onValueChange_mainStatePerson() {
        this.addValueFromInput(this.mainCountryPerson)
        let country = this.mainCountryPerson.getValue();
        //console.debug("_onValueChange_mainStatePerson", this.entityId, country)
        if (country && this.entityId) {

            this.contactAndCommunicationTable.setAddressContext(this.entityId, country);
        } else if (country) {

            this.contactAndCommunicationTable.updateCountry(country);
        }
    }


    private _onValueChange_state() {
        //this.addValue(this.country);
    }

    /*
    _onValueChange_isMusicianCheckBox(value: boolean) {
        this.UiModder.domClass.toggle(this.MusicianDataForm, "w3-hide", !value)
        if (value) {
            this.mandatoryFields = this.mandatoryFields.concat(this.musicianMandatoryFields);
        } else {
            this.musicianMandatoryFields.forEach(lang.hitch(this, this.removeMandatoryFields))
        }
        this.addValue(this.isMusicianCheckBox);
    }
    */

    private _onValueChange_isComposerCheckBox(value: boolean) {
        //this.ComposerDataForm.expander.toggleExpand(value);
        this.addValueFromInput(this.isComposerCheckBox)
    }

    private _onValueChange_isPerformerCheckBox(value: boolean) {
        //this.PerformerDataForm.expander.toggleExpand(value);
        this.addValueFromInput(this.isPerformerCheckBox)
    }

    private _onValueChange_isPerformerCheckBox2(value: boolean) {
        //this.PerformerDataForm.expander.toggleExpand(value);
        this.addValueFromInput(this.isPerformerCheckBox)
    }

    private _onValueChange_isContactPersonCheckBox(value: boolean) {
        //this.ContactDataForm.expander.toggleExpand(value);
        this.addValueFromInput(this.isContactPersonCheckBox);
    }

    private _onValueChange_isMainProfessionCheckBox(value: boolean) {

        //
    }

    private _onClick_NewContactPerson_Button(evt: MouseEvent) {
        /*
        if (this.ContactPersonForm) {
            this.UiModder.domConstruct.empty(this.ContactPersonForm.domNode);
        }
        */
        let form = new ContactPersonForm();
        //form.callback = lang.hitch(this, this._onClick_AddContactPerson_Button)

        let dlg = new GenericDialog();
        dlg.show(
            form,
            this.translate("AddressWizard__newContactPerson"),
            null, null,
            "okcancel",
            lang.hitch(this, this._onContactPersonDlgCallback, null, null)
        );

        this._currentContactPersonForm = form;

        let assignedOrganisationIDs = [];

        if (this.formData?.contactPerson?.length) {
            for (let value of this.formData.contactPerson) {
                assignedOrganisationIDs.push(value.organisation.ID);
            }
        }

        form.setup(this.entity?.ID, assignedOrganisationIDs);

        form.startup();

        dlg.disableButton("ok");
        form.on("changeOrganisation", lang.hitch(this, this._setOkButtonState, dlg));
        //form.placeAt(this.ContactPersonFormContainer)
        //this.UiModder.domClass.remove(this.ContactPersonForm.domNode, "w3-hide")
        //this.UiModder.domClass.remove(this.addContactPersonButton, "w3-hide")
        //this.UiModder.domClass.add(this.newContactPersonButton, "w3-hide")
    }

    private _setOkButtonState(dlg: MdsLax<InstanceType<typeof GenericDialog>>, value: AddressWizardTypes.Organisation) {
        if (value) {
            dlg.enableButton("ok");
        } else {
            dlg.disableButton("ok");
        }
    }


    private _onValueChange_composerBirthDate(value) {
        //let dateString = dojoDateLocale.format(value, { locale: 'de-de', datePattern: "dd.MM.yyyy", timePattern: "", selector: "date" })
        //this.composerBirthDate.setValue(dateString)
        this.addValueFromInput(this.composerBirthDate_Date);
        this._recalcComposerCheckbox();
        //console.log("_onValueChange_composerBirthDate");
        if (this.composerBirthDate_Date.getValue() != null) {
            this.UiModder.domClass.add(this.composerBirthDate.domNode, "w3-hide");
        } else {
            this.UiModder.domClass.remove(this.composerBirthDate.domNode, "w3-hide");
        }
    }

    private _onValueChange_composerDiedDate(value) {
        //let dateString = dojoDateLocale.format(value, { locale: 'de-de', datePattern: "dd.MM.yyyy", timePattern: "", selector: "date" })
        //this.composerDiedDate.setValue(dateString)
        this.addValueFromInput(this.composerDiedDate_Date);
        this._recalcComposerCheckbox();
        if (this.composerDiedDate_Date.getValue() != null) {
            this.UiModder.domClass.add(this.composerDiedDate.domNode, "w3-hide");
        } else {
            this.UiModder.domClass.remove(this.composerDiedDate.domNode, "w3-hide");
        }
    }

    private _onValueChange_composerBirthDateEdit() {
        this.addValueFromInput(this.composerBirthDate);
        this._recalcComposerCheckbox();
        //console.log("_onValueChange_composerBirthDateEdit");
    }

    private _onValueChange_composerDiedDateEdit() {
        this.addValueFromInput(this.composerDiedDate);

        this._recalcComposerCheckbox();
    }

    private _recalcComposerCheckbox() {
        this.isComposerCheckBox.setValue(!!(this.composerBirthDate.getValue() ||
            this.composerDiedDate.getValue() ||
            this.composerBirthDate_Date.getValue() ||
            this.composerDiedDate_Date.getValue()));

        this.checkSectionContents();
    }

    private _onValueChange_performerName() {
        this.addValueFromInput(this.performerName)
    }

    private _onValueChange_Profession() {
        this.addValueFromInput(this.profession);
    }

    private _onValueChange_organisation() {
        this.addValueFromInput(this.organisation);
    }

    private _onValueChange_jobTitle() {
        this.addValueFromInput(this.jobTitle);
    }

    private _onValueChange_contactField(value) {
        this.UiModder.domClass.toggle(this.addContactFieldButton, "w3-disabled", value == null)
    }

    private _updateTelecomLabels() {
        let totalCount = 0;
        for (let type in this.contactDataFields) {
            let entries: Array<TelecomReg> = this.contactDataFields[type];

            let iconClass = "";
            switch (type) {
                case "mobile":
                    iconClass = "fas fa-mobile secondaryTXT";
                    break;
                case "web":
                    iconClass = "fas fa-globe secondaryTXT";
                    break;
                case "webphone":
                    iconClass = "fas fa-headset secondaryTXT";
                    break;
                case "phone":
                    iconClass = "fas fa-phone secondaryTXT";
                    break;
                case "mail":
                    iconClass = "fas fa-at secondaryTXT";
                    break;
                case "fax":
                    iconClass = "fas fa-fax secondaryTXT";
                    break;
                case "messenger":
                    iconClass = "fas fa-comment secondaryTXT";
                    break;
            }

            let counter = 0;
            for (let entry of entries) {
                if (entry.deleted != true) {
                    counter++;
                    totalCount++;
                    let icon = this.createFontawesomeIcon(iconClass, "&nbsp;");
                    let label = icon.outerHTML + this.translate("AddressWizard__" + type) + " " + counter;
                    entry.input.setLabel(label);
                }
            }
        }

        this.sectionTelecom.expander.setMarking(totalCount > 0 ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
    }

    private _onClick_removeContactField(registry: TelecomReg) {

        let input = registry.input;
        registry.deleted = true;

        let fieldName = this.UiModder.domAttr.get(input.domNode, "name");
        let fieldType = this.UiModder.domAttr.get(input.domNode, "type");

        //this.contactDataFields[fieldType] = this.contactDataFields[fieldType].filter(data => data != fieldName);
        //delete this.allValues[fieldType][fieldName];
        //this.allValues[fieldType][fieldName] = "";
        if (this.formData[fieldType]) {
            this.formData[fieldType] = this.formData[fieldType].filter(data => data.fieldName != fieldName);
        }

        /*
        if (this.allValues[fieldType].length == 0) {
            delete this.allValues[fieldType];
        }
        */

        this.UiModder.domConstruct.destroy(input.domNode.parentNode);
        this.additionalContactFieldsCounter--;

        this._updateTelecomLabels();
        if (this.isDirty() == false){
            this.setDirty(true);
        }
    }


    //REQUESTS

    private _save() {
        let url = window.appRoot + "AddressWizard/SaveAddressEntity";

        console.log(this.id + " save", this.formData);

        this.StandbyStart();

        this.RequestManager.post(
            url,
            {
                jsonData: JSON.stringify(this.formData)
            },
            lang.hitch(this, this._onSaveAddressDataResponse),
            lang.hitch(this, this._onSaveAddressDataError),
            false // sync
        );
    }



    private _getProfessionalTitles() {
        this.StandbyStart();
        this.RequestManager.callfunction(
            "Webtool_API_AddressWizard__GetProfessionalTitles",
            {},
            lang.hitch(this, this._onLoadProfessionalTitlesResponse),
            lang.hitch(this, this._onLoadProfessionalTitlesError)
        )
    }

    private _getSalutations() {
        var url = window.appRoot + "AddressWizard/GetSalutations";
        this.hourGlassStart(this.salutation);

        this.RequestManager.post(
            url,
            {},
            lang.hitch(this, this._onLoadSalutationsResponse),
            lang.hitch(this, this._onLoadSalutationsError),
            false // sync
        );
    }



    private _getTitlePrefix() {
        var url = window.appRoot + "AddressWizard/GetTitlePrefix";
        this.hourGlassStart(this.titlePrefix);

        this.RequestManager.post(
            url,
            {},
            lang.hitch(this, this._onLoadTitlePrefixResponse),
            lang.hitch(this, this._onLoadTitlePrefixError),
            false // sync
        );
    }

    private _getTitleSuffix() {
        var url = window.appRoot + "AddressWizard/GetTitleSuffix";
        this.hourGlassStart(this.titleSuffix);

        this.RequestManager.post(
            url,
            {},
            lang.hitch(this, this._onLoadTitleSuffixResponse),
            lang.hitch(this, this._onLoadTitleSuffixError),
            false // sync
        );
    }

    private _onClick_VATCheck_Button() {

        if (this.isDirty()) {
            ToasterHelpers.showToast("General_PendingChangesMustBeSavedFirst", toasterIcons.warning);
            return;
        }

        let url = window.appRoot + "AddressWizard/CheckVAT";
        let VATValue = this.vatNr.getValue();
        let id = this.entity?.ID;
        //console.log("jsonData", JSON.stringify(this.allValues));
        this.StandbyStart(this.sectionVAT);
        this.disableNode(this.btnVatCheck);

        this.RequestManager.post(
            url,
            {
                jsonData: JSON.stringify({ id: id, vat: VATValue })
            },
            lang.hitch(this, this._onVATCheckDataResponse),
            lang.hitch(this, this._onVATCheckDataError),
            false // sync
        );

    }
    private _getLanguages() {
        this.hourGlassStart(this.language);

        this.RequestManager.callfunction(
            "Webtool_API_AddressWizard_GetLanguagesData",
            {},
            lang.hitch(this, this._onLoadLanguagesResponse),
            (err) => {
                alert("ERROR beim _onLoadLanguagesError: " + err.Message);
                this.hourGlassEnd(this.language);
            },
            false // sync
        );
    }



    //RESPONSES

    private _onLoadLanguagesResponse(response) {
        let preset = this.language.getValue();
        this._processSelectBoxValues(this.language, response);
        if (preset) this.language.setValue(preset);
        //this.StandbyStop();
        this.completeStartupStep("language");
        this.hourGlassEnd(this.language);
    }

    private _onSaveAddressDataResponse(response: Types.GetDataResponse) {
        this.StandbyStop();

        this.showToast({
            title: this.translate("General_SavingSuccessful"),
            options: {
                ID: "saved",
                //timeout: 5000
            },
            iconClass: ToasterHelpers.ToasterIcons.save
        });
        this.applyData(response);
        this.setDirty(false);
        this.emit("saveComplete");
        this.emit("saved");
    }

    private _onLoadProfessionalTitlesResponse(response) {
        //console.log(this.formData["professionalTitle"], response);
        let preset = this.professionalTitle.getValue();
        this.professionalTitle.setBlankOption("", "--", true);
        this.professionalTitle.setData(preset ? preset : this.formData["professionalTitle"], response, "ID", "description_short");

        this.StandbyStop();
    }

    private _onLoadSalutationsResponse(response) {
        let preset = this.salutation.getValue();
        this._processSelectBoxValues(this.salutation, response, "description");
        if (preset) this.salutation.setValue(preset);

        this.completeStartupStep("salutations");
        //this.StandbyStop();
        this.hourGlassEnd(this.salutation);
    }

    private _onLoadTitlePrefixResponse(response) {
        let preset = this.titlePrefix.getValue();
        this._processSelectBoxValues(this.titlePrefix, response, "description_short", "description");
        if (preset) this.titlePrefix.setValue(preset);
        //this.StandbyStop();
        this.completeStartupStep("titlePrefix");
        this.hourGlassEnd(this.titlePrefix);
    }

    private _onLoadTitleSuffixResponse(response) {
        let preset = this.titleSuffix.getValue();
        this._processSelectBoxValues(this.titleSuffix, response, "description_short", "description");
        if (preset) this.titleSuffix.setValue(preset);
        //this.StandbyStop();
        this.completeStartupStep("titleSuffix");
        this.hourGlassEnd(this.titleSuffix);
    }



    private _onGetAddressByIdResponse(response: Types.GetDataResponse) {
        //this._processSelectBoxValues(this.functionalSubGroup, response, "description");
        // this.StandbyStop();
        //console.log(response);
        this.applyData(response);
    }

    private _onVATCheckDataResponse(response: Types.Address_VATattributes) {

        this.entity.is_VAT_No_valid = response.is_VAT_No_valid;
        this.entity.VAT_no_checked_at = response.VAT_no_checked_at;

        this.setVATCheckStyle();

        this.StandbyStop();
    }
    private _onVATCheckDataError(err: more.requestErrorMessage) {
        alert(err.Message + " (_onVATCheckDataError)");
        this.StandbyStop();
        this.setVATCheckStyle();
    }



    //ERRS

    private _onSaveAddressDataError(err: more.requestErrorMessage) {
        this.StandbyStop();
        //alert("ERROR beim _onSaveAddressDataError: " + err.Message);

        this.showToast({
            title: "ERROR beim Speichern der Daten!",
            message: err.Message,
            iconClass: toasterIcons.error,
            messageIcon: toasterIcons.error
        })
    }

    private _onLoadProfessionalTitlesError(err: more.requestErrorMessage) {
        this.StandbyStop();
        console.error(err);
    }

    private _onLoadSalutationsError(err: more.requestErrorMessage) {
        alert("ERROR beim _onLoadSalutationsError: " + err.Message);
        this.hourGlassEnd(this.salutation);
    }

    private _onLoadTitlePrefixError(err: more.requestErrorMessage) {
        alert("ERROR beim _onLoadTitlePrefixError: " + err.Message);
        this.hourGlassEnd(this.titlePrefix);
    }

    private _onLoadTitleSuffixError(err: more.requestErrorMessage) {
        alert("ERROR beim _onLoadTitleSuffixError: " + err.Message);
        this.hourGlassEnd(this.titleSuffix);
    }



    private _onGetAddressByIdError(err: more.requestErrorMessage) {
        alert("ERROR beim _onGetAddressByIdError: " + err.Message);
    }



    //OTHERS

    private removeMandatoryFields(field) {
        this.mandatoryFields = this.mandatoryFields.filter(data => data != field);
    }

    private _getSelectboxData() {
        this.addStartupStep("salutations");
        this.addStartupStep("titlePrefix");
        this.addStartupStep("titleSuffix");
        this._getProfessionalTitles();
        this._getSalutations();
        this._getTitlePrefix();
        this._getTitleSuffix();

        if (this.hasFeature("AddressWizard/LanguageSelect")) {

            this.hideNode(this.languageSelectContainer, false);

            this.addStartupStep("language");
            this._getLanguages();
        }

        //this._getFunctionalSubGroup();
        //this.populateCountrySelect(this.citizenship);

    }

    private addValueFromInput(input: MdsLax<InstanceType<typeof _StatefulBase>>): void {
        if (this._isDataLoading === true) return;
        this.setDirty(true);
        let widgetName: string = typeof this.getAttachPointNameForWidget(input) == "undefined"
            ? this.UiModder.domAttr.get(input.domNode, "name")
            : this.getAttachPointNameForWidget(input);
        if (input.getValue && input.validateInput()) {

            let widgetValue: any = input.getValue();


            this.formData[widgetName] = widgetValue;
        } else {
            delete this.formData[widgetName];
        }

        this.checkSectionContents();

        console.log(this.id + " value added", widgetName, this.formData);
    }

    private addContactFieldValue(regEntry: TelecomReg, fieldType: string, ID?: string): void {
        this.setDirty(true);

        let input: MdsLax<InstanceType<typeof _StatefulBase>> = regEntry.input;

        let widgetName: string = typeof this.getAttachPointNameForWidget(input) == "undefined"
            ? this.UiModder.domAttr.get(input.domNode, "name")
            : this.getAttachPointNameForWidget(input);

        if (input.getValue() && input.validateInput()) {


            let widgetValue: any = input.getValue();

            if (!this.formData[fieldType]) {
                this.formData[fieldType] = [];
            }
            //this.allValues[fieldType][widgetName] = { value: widgetValue };

            let obj = this.formData[fieldType].find(data => data.fieldName == widgetName);
            if (obj) {
                obj.value = widgetValue
            } else {
                this.formData[fieldType].push({ fieldName: widgetName, value: widgetValue, ID: ID })
            }


        } else {
            if (this.formData[fieldType]) {
                //delete this.allValues[fieldType][widgetName];
                this.formData[fieldType] = this.formData[fieldType].filter(data => data.fieldName != widgetName);
            }
        }

        //console.debug("addContactFieldValue", fieldType, this.allValues[fieldType]);

        this.checkSectionContents();
    }
    // ... Das gleiche ^^^ für Dates, um den string im Format YYYY-MM-DDTHH:mm:ss zu bekommen
    addDateValue(input: MdsLax<InstanceType<typeof DateInput>>): void {
        //this._setHasChanged(true);
        //if (input.validateInput(input.getValue())) {
        //    this.allValues[this.getAttachPointNameForWidget(input)] = input.toStringISO(input.getValue()).substr(0, 10);
        //} else {
        //    delete this.allValues[this.getAttachPointNameForWidget(input)];
        //}

    }

    private getAttachPointNameForWidget(widget: MdsLax<InstanceType<typeof _StatefulBase>>): string {
        for (let attachPointName of this._attachPoints) {
            if (this[attachPointName] == widget) {
                return attachPointName;
            }
        }
    }

    private _editCaseCamel(value: string, eachWord: boolean = true): string {

        value = value.trim();

        if (value.length != 17 && value.indexOf(":") != 8) { // wenn das keine id ist
            let words: Array<string> = value.split(" ");
            let camelCasedWords: Array<string> = [];
            if (words && words.length && eachWord === true) {
                for (let word of words) {
                    let lowerCale: string = word.slice(1).toLowerCase();
                    let firstCase: string = word.slice(0, 1).toUpperCase();
                    camelCasedWords.push(firstCase + lowerCale);
                }

                return camelCasedWords.join(" ");
            } else {
                let lowerCale: string = value.slice(1).toLowerCase();
                let firstCase: string = value.slice(0, 1).toUpperCase();

                return firstCase + lowerCale;
            }
        } else {
            // sont unmodifiziert zurück geben
            return value;
        }
    }

    private _processSelectBoxValues(selectBox: MdsLax<InstanceType<typeof SelectBox>>, items, field = "description", fallbackField?: string) {
        //set data for StateSelectbox
        this._data_SelectionValues = items;

        for (let entity of this._data_SelectionValues) {
            let label = entity[field];
            if (fallbackField && !label) label = entity[fallbackField]
            if (!label) label = entity.ID;
            selectBox.addOption(entity.ID, label, true);
        }

        selectBox.setBlankOption("", "--", true);

        selectBox.constructOptions();

        selectBox.startup();

    }


    private addPreferredCountries(): void {

        for (let i = 0; i < this.preferredCountries.length; i++) {
            let countryName: string = this.preferredCountries[i];
            for (let i = 0; i < this.AllCountriesData.length; i++) {

                if (this.AllCountriesData[i].iso2 == countryName) {
                    this.topCountries.push(this.AllCountriesData[i]);
                }
            }
        }

        //countries.unshift(...topCountries);
    }

    private populateCountrySelect(node: MdsLax<InstanceType<typeof SelectBox>>): void {

        for (var i = 0; i < this.topCountries.length; i++) {
            let country = this.topCountries[i];
            node.addEntry(country.iso2, country.name, true);
        }

        node.addEntry("", "&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473&#9473", false);

        for (var i = 0; i < this.AllCountriesData.length; i++) {
            let country = this.AllCountriesData[i];
            node.addEntry(country.iso2, country.name, true);
        }

        node.on("valueChange", function (value) { });
        node.setPlaceholder(this.translate("PersonData__SelectBox_pleaseChoose"));

        node.startup();

    }

    private _createTable(table: HTMLTableElement, data: Array<any>, editFunction: Function = null) {

        this.UiModder.domConstruct.empty(table);

        if (data.length) {

            let fields = Object.keys(data[0]);

            let tr = table.insertRow();
            fields.forEach(lang.hitch(this, this._addTableHeads, tr))
            data.forEach(lang.hitch(this, this._createTableRows, table, fields, editFunction));
        }

        this.checkSectionContents();
    }

    private _addTableHeads(tableRow: HTMLTableRowElement, field: string) {
        if (field != "type" && field != "data" && field != "form" && field != "entity") {
            //console.log(field);
            this.UiModder.domConstruct.create("th", { "innerHTML": "<b>" + this.translate("AddressWizard__" + field) + "</b>" }, tableRow)
        }
    }

    private _createTableRows(table, fields, editFunction, data) {
        let tr = table.insertRow();

        fields.forEach(lang.hitch(this, this._createTableCell, data, tr))
        let td = this.UiModder.domConstruct.create('td')
        this.UiModder.domAttr.set(td, "nowrap", true)

        if (table == this.filesTable) {

            let btnDownload = new Button();
            btnDownload._onClick_Button = lang.hitch(this, this._downloadFile, data);
            btnDownload.setLabel("");
            let dlIcon = "fas fa-download";
            if (this.hasFeature("filePreview", "useInAddressWizard")){
                dlIcon = "fas fa-search";
            }
            btnDownload.setIconLeft(dlIcon);
            btnDownload.setClasses("mds-button-base hoverBright secondaryBG w3-small downloadBtn");
            this.UiModder.domStyle.set(btnDownload.domNode, "float", "left");

            btnDownload.placeAt(td);
        }

        if (this.hasFeature("Address/VCardGenerator")) {
            if (table == this.orgContactPersonTable || table == this.contactPersonTable) {
                let entityId = data?.entity?.ID;
                let btnVCard = new Button();
                btnVCard._onClick_Button = lang.hitch(this, this.openVCardGenerator, entityId);
                btnVCard.setLabel("");
                btnVCard.setIconLeft("fas fa-address-card");
                btnVCard.setClasses("mds-button-base hoverBright secondaryBG w3-small");
                this.UiModder.domStyle.set(btnVCard.domNode, "float", "left");
                if (!entityId) btnVCard.disableNode(btnVCard.domNode);
                btnVCard.placeAt(td);
                let tooltip = new Tooltip();
                tooltip.setup({
                    content: this.translate("AddressWizard__Label_VCardGenerator"),
                    targetnode: btnVCard.domNode,
                    delayMS: 100
                })
            }
        }

        if (editFunction) {
            let param = this.formData[data.type]?.filter(row => row == data)[0];
            let btnEdit = new Button();
            btnEdit._onClick_Button = lang.hitch(this, editFunction, param, tr);
            btnEdit.setLabel("");
            btnEdit.setIconLeft("fas fa-edit");
            btnEdit.setClasses("mds-button-base hoverBright secondaryBG w3-small editBtn");
            this.UiModder.domStyle.set(btnEdit.domNode, "float", "left");

            if (table == this.bankAccountTable) {
                if (this.canEditFinance != true) {
                    btnEdit.setReadonly(true);
                } else {
                    btnEdit.setReadonly(false);
                }
            }

            btnEdit.placeAt(td);
        }

        if (table != this.orgContactPersonTable) {
            let btnRemove = new Button();
            btnRemove._onClick_Button = lang.hitch(this, this._removeTableRow, tr, data, table);
            btnRemove.setLabel("");
            btnRemove.setIconLeft("fas fa-trash warningTXT");
            btnRemove.setClasses("mds-button-base hoverBright secondaryBG w3-small deleteBtn");
            this.UiModder.domStyle.set(btnRemove.domNode, "float", "left");

            if (table == this.bankAccountTable) {
                if (this.canEditFinance != true) {
                    btnRemove.setReadonly(true);
                } else {
                    btnRemove.setReadonly(false);
                }
            }

            btnRemove.placeAt(td);
        }

        if (table == this.contactPersonTable) {

            //console.debug("contactPersonTable data", data);

            if (typeof data.organisation?.is_active != "undefined" && data.organisation?.is_active !== true) {


            }
        }

        this.UiModder.domConstruct.create(td, { "style": "float: right" }, tr);

    }

    private _onClickMainProfessionCheckbox(checkBox: MdsLax<InstanceType<typeof CheckBox>>, data, e) {
        if (!e) {
            checkBox.setValue(true, true);
            return;
        }

        for (let performer of this.formData.performer) {
            performer.isMainProfession = data["profession"].value === performer["profession"].value;
        }
        this._createTable(this.performerTable, this.formData.performer);
        this.setDirty(true);
    }

    private _createTableCell(data, tr, field) {
        if (field != "type" && field != "form" && field != "data" && field != "entity") {
            try {
                let value;
                let type = typeof data[field];



                if (type == "object") value = data[field]["value"];
                else if (type == "boolean") value = data[field] ? '<i class="fas fa-check"></i>' : "";
                else value = data[field];

                //let value = typeof data[field] == "object" ? data[field]["value"] : data[field];
                if (field === "organisation"
                    && typeof data.organisation?.is_active != "undefined"
                    && data.organisation?.is_active !== true) {
                    let td = this.UiModder.domConstruct.create('td', {
                        "innerHTML": value ? value : "",
                        "class": "w3-text-gray"
                    }, tr);
                    let ico = this.createFontawesomeIcon("fas fa-warning", "&nbsp");
                    this.UiModder.domConstruct.place(ico, td, "first");
                    let tooltip = new Tooltip();
                    tooltip.setup({
                        content: this.translations["AddressWizard_Tooltip_InactiveOrganization"],
                        targetnode: ico,
                        enableHover: true,
                        delayMS: 200
                    });
                } else if (field === "isMainProfession") {
                    let td = this.UiModder.domConstruct.create("td", null, tr);
                    let checkBox = new CheckBox();
                    checkBox.setValue(data[field], true);
                    checkBox.placeAt(td);
                    checkBox.on("change", lang.hitch(this, this._onClickMainProfessionCheckbox, checkBox, data));
                } else {

                    this.UiModder.domConstruct.create('td', {
                        "innerHTML": value ? value : ""
                    }, tr);
                }
            } catch (ex) {
                console.warn(this.id + ": _createTableCell failed for " + field, ex, data);
            }
        }
    }

    private _removeTableRow(tr, data, table: HTMLTableElement) {

        //console.log("_removeTableRow", data);

        this.UiModder.domConstruct.destroy(tr);
        if (table.rows.length == 1) {
            this.UiModder.domConstruct.empty(table);
        }
        if (table == this.filesTable) {

            this.formData["filesToDelete"].push(data["fileData"]);
        } else {
            if (this.formData[data.type]) {
                this.formData[data.type] = this.formData[data.type].filter(row => row != data);
            }
        }
        this.emit("tableRowRemoved");
        if (data.type == "contactPerson") {
            //this.UiModder.domClass.remove(this.newContactPersonButton, "w3-hide")
            this.UiModder.domConstruct.empty(this.ContactPersonFormContainer);
        }

        if (data.type == "addressCategory") {
            //this._updateAddressCategoryFromFormData(); // nimmer nötig
            this.store_AddressCategories.deleteEntry(data.addressCategory);
        }



        this.setDirty(true);

        this.checkSectionContents();
    }

    _downloadFile(data) {
        if (this.hasFeature("filePreview","useInAddressWizard") == false){
            window.open(window.appRoot + `AddressWizard/DownloadExistingFile?downloadKey=${data["fileData"]["ID"]}`);
        }else{
            let key = { key: data["fileData"]["ID"]};
            this.filePreviewWidget = new filePreview();
            this.StandbyStart();
            this.filePreviewWidget.show(
                key,
                true,
                true,
                lang.hitch(this,
                    ()=>{
                        this.StandbyStop();
                    }),
                lang.hitch(this, (err) => {
                    console.error(err);
                    this.showToast( this.translations["General_Error"]+ err, "fas fa-bug");
                    this.StandbyStop();
                })
            );
        }
    }

    private createCollapseButton(targetNode: HTMLElementWithExpander, id?: string, bDoCollapse?: boolean): HTMLElementWithExpander {

        if (id) {
            let existingNodes = dojoQuery("#" + id, targetNode);
            if (existingNodes.length > 0) {
                return; // wenn collapse button bereits vorhanden, dann nichts hinzufügen
            }
        }

        let headingNodes = dojoQuery(".expanderHeading", targetNode);
        let heading: any = "??";
        if (headingNodes.length) {
            heading = headingNodes[0];
        }

        let expanderSection = new ExpandableSection();
        let result = expanderSection.setupAsReplacement(targetNode, heading, "medium", true, true, bDoCollapse !== true);
        expanderSection.id = id ? id : (Math.random() * 10000).toFixed(0).toString();

        //this._expandableNodes.push({ expanderWidget: expanderSection, id: id, targetNode: targetNode });
        this.hideNode(expanderSection.domNode);

        return result;
    }
    private setupExpanders() {
        this.ComposerDataForm = this.createCollapseButton(this.ComposerDataForm, "composerExpander", true);
        if (!FeatureHelpers.hasModuleVersion("Address", 251201.0000)) this.PerformerDataForm = this.createCollapseButton(this.PerformerDataForm, "performerExpander", true);

        this.ContactPersonDataForm = this.createCollapseButton(this.ContactPersonDataForm, "contactPersonExpander", true);
        this.FinanceDataForm = this.createCollapseButton(this.FinanceDataForm, "financeExpander", true);
        this.sectionAddressDocuments = this.createCollapseButton(this.sectionAddressDocuments, "addressDocumentsExpander", true);
        this.sectionFurtherAddresses = this.createCollapseButton(this.sectionFurtherAddresses, "furtherAddressesExpander", true);
        this.OrganizationContactPersonDataForm = this.createCollapseButton(this.OrganizationContactPersonDataForm, "orgContactPersonsExpander", true);
        this.sectionTelecom = this.createCollapseButton(this.sectionTelecom, "contactExpander", true);
        this.AddressCategoryDataForm = this.createCollapseButton(this.AddressCategoryDataForm, "addressCategoryExpander", true);
        this.FileDataForm = this.createCollapseButton(this.FileDataForm, "fileFormExpander", true);

        this.GDPRSectionExpander = this.createCollapseButton(this.GDPRSectionExpander, "GDPRSectionExpander", true);

    }
    //private _expandableNodes: Array<{ expanderWidget: ExpandableSection, id: string, targetNode: HTMLElement }> = [];


    //showToast(message: string | false, ID: string, timeout?: number | false | "permanent", icon?: toasterIcons, extendedMessage?: string, options?: toastOptions) {

    //    let defaultIcon: toasterIcons = toasterIcons.confirmCheck;

    //    if (message === false) {
    //        this.toaster.removeToastById(ID);
    //    }
    //    else {

    //        if (typeof (icon) != "undefined") {
    //            defaultIcon = icon;
    //        }

    //        let defaultOptions: toastOptions = {
    //            closeButton: typeof (timeout) == "undefined" ? true : false, timeout: typeof (timeout) == "number" ? timeout : -1
    //        };

    //        if (typeof (options) != "undefined" && options != null) {
    //            defaultOptions = options;
    //        }

    //        defaultOptions.ID = ID;

    //        if (timeout === false) {
    //            //defaultOptions.close = true;
    //        } else if (typeof (timeout) == "number") {
    //            defaultOptions.timeout = timeout;
    //        }
    //        else if (timeout == "permanent") {
    //            defaultOptions.timeout = timeout;
    //        } else {
    //            defaultOptions.timeout = 5000;
    //        }

    //        if (extendedMessage != null && typeof (extendedMessage) != "undefined") {
    //            defaultOptions.onClick = {
    //                callback: lang.hitch(this, this.showErrorDetailsDlg, extendedMessage, message, null, "close", null)
    //            };

    //            this.toaster.addToast(message, defaultIcon, defaultOptions);
    //        }
    //        else {
    //            this.toaster.addToast(message, defaultIcon, defaultOptions);
    //        }
    //    }
    //}

    //showErrorDetailsDlg(message, header, subtitle, buttons, callback) {
    //    let dlg = new GenericDialog();
    //    dlg.show(message, header, subtitle, null, buttons, callback);}

    private _onClick_Delete_Button() {
        let dlg = new GenericDialog();

        dlg.show(
            this.translate("General_ConfirmDeleteMessage"),
            this.title,
            this.translate("General_ConfirmDeleteSubtitle"),
            "fas fa-exclamation-triangle",
            "yesno",
            lang.hitch(this, this._onConfirmDeletion)
        );
    }

    private _onConfirmDeletion(result: number) {
        if (result >= 2) // ja
        {
            this.deleteAddress();
        }
    }

    private deleteAddress() {
        if (!this._lastLoadedData["address"]["ID"]) {
            return;
        }
        this.StandbyStart();

        let data = {
            entityID: this._lastLoadedData["address"]["ID"]
        };

        let url = window.appRoot + "AddressWizard/DeleteAddressEntity";

        this.RequestManager.post(
            url,
            {
                "jsonData": JSON.stringify(data)
            },
            lang.hitch(this, this._onDeleteResponse),
            lang.hitch(this, this._onDeleteError),
            false // sync
        );
    }


    onEntityUpdated: Function = null;


    private _onDeleteResponse(response: { Exception: boolean, Message: string }) {

        //this.setDirty(false);


        this.StandbyStop();

        //if (typeof (this.onEntityUpdated) == "function") {
        //    this.onEntityUpdated(this.entityData);
        //}

        if (this.isEmbeddedInTab) {
            this.closeTab();
        }
    }



    private _onDeleteError(error: more.requestErrorMessage) {
        this.StandbyStop();

        alert(error.Message);
    }

    _valueHasChanged() {
        //console.log("valChange")
    }

    isDirty() {
        return this._isDirty;
    }

    getDirty(): boolean {
        return this._isDirty;
    }

    setDirty(flag: boolean) {
        if (this._isDataLoading == true) return;

        if (this._isDirty != flag) {
            this._isDirty = flag;

            this.emit("dirty", flag);
        }
        this.requestContextButtonEnable("save", this._isDirty === true);
        this.requestContextButtonEnable("rollback", this._isDirty === true);

        //console.debug("isDirty", this._isDirty, this.entity);
    }

    getEntityId(): string {
        if (this.entity) return this.entity.ID;

        return this.formData["ID"];
    }

    getDisplayName(): string {
        if (!this._isDirty) {
            if (this.entity?.gDisp_Firstname_Name) return this.entity.gDisp_Firstname_Name;
        }

        if (this.selectedAddressType == "person") {
            let firstname = this.firstname.getValue();
            let surname = this.surname.getValue();

            let disp = (firstname ? firstname : "") + (surname ? " " + surname : "");
            disp.trim();

            if (disp) return disp;

        } else {
            let name1 = this.name1.getValue();
            let name2 = this.name2.getValue();
            let name3 = this.name3.getValue();

            let disp = (name1 ? name1 : "") + (name2 ? " " + name2 : "") + (name3 ? " " + name3 : "");

            disp.trim();

            if (disp) return disp;
        }

        return this.translate("Addresses__CreateNew");
    }

    private goto(target: string) {
        if (this[target]) {
            let element: HTMLElementWithExpander = this[target];
            //element.scrollIntoView({ behavior: "smooth" });

            if (element) {

                if (element.expander) {
                    element.expander.toggleExpand(true);

                    element = element.expander.domNode as HTMLElementWithExpander;
                }

                window.scrollTo({ top: element.offsetTop, behavior: "smooth" });


            }
        }
    }

    private openGooglePlacesWidget() {

        this.googlePlaces = new GooglePlacesWidget(this.entity);
        let dlg = new GenericDialog();
        dlg.show(this.googlePlaces, this.translate("GooglePlacesWidget_Header_GoogleSearch"), null, null, "close");
        dlg.addButton("transfer_data",
            this.translate("GooglePlacesWidget_Label_TransferDataBtn"),
            lang.hitch(this, this.transferDataFromGooglePlaces),
            null, "primaryBG", null, true, "first", false);
        this.googlePlaces.on("place_changed", lang.hitch(dlg, dlg.enableButton, "transfer_data"));
    }
    private transferDataFromGooglePlaces() {
        let data: Array<{ key: string, value: string, transferData?: boolean }> = this.googlePlaces.getCurrentPlaceData();
        //console.debug("getCurrentPlaceData", data)

        let table = new StaticTable();
        table.setLayout({
            "rows": [
                {
                    "attributes": [
                        "key",
                        "transer",
                        "value"
                    ],
                    "headings": [
                        "GooglePlacesWidget_DataTable_Header_DataName",
                        "GooglePlacesWidget_DataTable_Header_DataCheck",
                        "General_Label_Value"
                    ],
                    "colspans": [
                        1,
                        1,
                        1
                    ],
                    "widths": [
                        "",
                        "10ch",
                        ""
                    ],
                    "colNamesInternal": [
                        "key",
                        "transer",
                        "value"
                    ]
                }
            ],
            "name": "default",
            "label": "default",
            "layoutStyle": "auto"
        })
        table.setFormatter((cell) => {
            switch (cell.name) {
                case "transer":
                    this.UiModder.domClass.add(cell.contentnode, "w3-center");
                    let checkedValue = typeof (cell.entity as any).transferData == "undefined" ? true : (cell.entity as any).transferData;
                    let input = this.UiModder.domConstruct.create("input", { type: "checkbox", checked: checkedValue, style: "transform: scale(1.34);" }, cell.contentnode);
                    cell.entity["transferData"] = true;
                    input.onchange = (evt: Event) => {
                        cell.entity["transferData"] = evt.target["checked"];
                    }
                    return true;

                case "key":
                    switch (cell.value) {
                        case "name":
                            cell.contentnode.innerHTML = this.translate("AddressWizard__Name1")
                            break;
                        case "locality":
                            cell.contentnode.innerHTML = this.translate("AddressWizard__city")
                            break;
                        case "street":
                            cell.contentnode.innerHTML = this.translate("AddressWizard__street")
                            break;
                        case "country":
                            cell.contentnode.innerHTML = this.translate("General_Label_Country")
                            break;
                        case "postal_code":
                            cell.contentnode.innerHTML = this.translate("AddressWizard__plz")
                            break;
                        case "international_phone_number":
                            cell.contentnode.innerHTML = this.translate("General_Label_phone")
                            break;
                        case "website":
                            cell.contentnode.innerHTML = this.translate("AddressWizard__web")
                            break;
                        default:
                    }
                    return true;
            }
            return false;
        })
        table.setData(data)

        let dlg = new GenericDialog();

        dlg.show(table,
            this.translate("GooglePlacesWidget_Header_TableDialog"),
            null,
            null,
            "ok", () => {
                let timeoutHandler = null;
                let changedHintboxData = [];
                console.debug("DEBUG DATA", data);
                data.forEach(p => {

                    if (!p.transferData) return;
                    switch (p.key) {
                        case "name":
                            this.name1.setValue(p.value);
                            break;
                        case "street":
                            this.mainStreetCompany.setValue(p.value);
                            break;
                        case "locality":
                        case "country":
                        case "postal_code":
                            if (timeoutHandler) clearTimeout(timeoutHandler);
                            changedHintboxData.push(p);
                            timeoutHandler = setTimeout(lang.hitch(this, this.GetDataForGooglePlacesHitboxTransfer, changedHintboxData), 500)
                            break;
                        case "international_phone_number":
                            this.contactAndCommunicationTable.addTelecomEntry_Remote("phone_numbers", p.value);
                            break;
                        case "website":
                            this.contactAndCommunicationTable.addTelecomEntry_Remote("web_addresses", p.value);
                            break;
                    }
                })
            }
        );
        table.setCyAttribute("googlePlaces");
    }
    private GetDataForGooglePlacesHitboxTransfer(changedData) {
        this.StandbyStart();

        this.RequestManager.callfunction("Webtool_API_GooglePlacesWidget__GetDataForChangedHintboxes",
            changedData,
            (response: Array<any>) => {
                response.forEach(o => {
                    let input = null;
                    switch (o.name) {
                        case "city":
                            input = this.mainCityCompany;
                            break;
                        case "postal_code":
                            input = this.mainPlzCompany;
                            break;
                        case "country":
                            input = this.mainCountryCompany;
                            break;
                    }


                    if (o.is_found) {
                        input.setValue(o.object);
                    } else {
                        input.setValue(o.plainTextValue);
                    }
                })
                this.StandbyStop();
            },
            (err: any) => {
                alert(err.Message);
                this.StandbyStop();
            }
        )
    }

    private _onChange_selectedAddressType() {

        if (this.hasFeature("Address/GooglePlacesIntegration") && this.selectedAddressType == "company") {
            this.requestContextButton({
                callback: lang.hitch(this, this.openGooglePlacesWidget),
                label: this.translate("AddressWizard__Label_GooglePlacesWidget"),
                iconClass: "fab fa-google",
                permanent: false,
                placement: "actionbar",
                enabled: true,
                order: 20,
                name: "googlePlacesWidget"
            });
        }
    }

    _onEmbedding() {
        this._drawActionbuttons();
        this.hideNode(this.saveButtonContainer);
    }

    private _drawActionbuttons() {

        let config: Tabbing.ContextActionButtonRequest = {
            callback: lang.hitch(this, this.goto, "sectionTelecom"),
            label: this.translate("AddressWizard__ContactData"),
            //iconClass: "fas fa-phone",
            permanent: false,
            placement: "actionbar",
            name: "telecomSection"
        };

        this.requestContextButton({ ...config });

        if (this.hasFeature("Address/VCardGenerator")) {
            this.requestContextButton({
                callback: () => { this.openVCardGenerator(this.entityId) },// lang.hitch(this, this.openVCardGenerator, this.entityId) geht nicht, gibts ein Race und this.entityId ist noch undefined
                label: this.translate("AddressWizard__Label_VCardGenerator"),
                iconClass: "fas fa-address-card",
                permanent: false,
                placement: "actionbar",
                enabled: this.entityId != null,
                order: 30,
                name: "vCard"
            });
        }

        //config.placement = "topmenu";
        //this.requestContextButton({
        //    callback: lang.hitch(this, this.goto, "ContactDataForm"),
        //    label: this.createFontawesomeIcon("fas fa-phone", "&nbsp;").outerHTML + this.translate("AddressWizard__ContactData"],
        //    permanent: false,
        //    placement: "topmenu"
        //});

        this.requestContextButton({
            callback: lang.hitch(this, this.goto, "AddressCategoryDataForm"),
            label: this.translate("AddressWizard__addressCategory"),
            iconClass: "fas fa-cubes",
            permanent: false,
            placement: "actionbar"
        });

        this.requestContextButton({
            callback: lang.hitch(this, this.goto, "FinanceDataForm"),
            label: this.translate("AddressWizard__FinanceDataForm_H1"),
            iconClass: "fas fa-money-check-alt",
            permanent: false,
            placement: "actionbar"
        });

        if (this.hasFeature("Address/AddressDocumentsSection")) {
            this.requestContextButton({
                callback: lang.hitch(this, this.goto, "sectionAddressDocuments"),
                label: this.translate("AddressWizard__AddressDocuments"),
                iconClass: "fas fa-id-card",
                permanent: false,
                placement: "actionbar",
                name: "addressDocumentsBtn"
            });
        }
        if (this.hasFeature("Address/FurtherAddressesSection")) {
            this.requestContextButton({
                callback: lang.hitch(this, this.goto, "sectionFurtherAddresses"),
                label: this.translate("AddressWizard__Label_FurtherAddresses"),
                iconClass: "fas fa-address-book",
                permanent: false,
                placement: "actionbar",
                name: "furtherAddressesBtn"
            });
        }
        
        if (FeatureHelpers.hasModuleVersion("Address", 251201.0000)) {
            this.requestContextButton({
                callback: lang.hitch(this, this.goto, "performerSectionContainer"),
                label: this.translate("AddressWizard__PerformerData"),
                iconClass: "fas fa-microphone",
                permanent: false,
                placement: "actionbar",
                name: "performerSectionBtn"
            });
        }

        this.requestContextButton({
            callback: lang.hitch(this, this.goto, "FileDataForm"),
            label: this.translate("AddressWizard__FileUpload"),
            iconClass: "fas fa-paperclip",
            permanent: false,
            placement: "actionbar"
        });


        if (this.hasFeature("Address/ExtendedPropertyList")) {
            this.requestContextButton({
                callback: lang.hitch(this, this.goto, "FileDataForm"),
                label: "General_Label_ExtendedProperties",
                iconClass: "far fa-list-alt",
                permanent: false,
                placement: "actionbar",
                name: "extendedPropertyList",
                enabled: false //damit bei before first save disabled ist (da ausgeblendet) und dann enabled wird
            });
        }
        if (this.hasUserRole("Addresses_GDPR")) {
            this.requestContextButton({
                callback: lang.hitch(this, this.goto, "GDPRSectionExpander"),
                label: this.translate("AddressWizard__Label_GDPR"),
                iconClass: "fas fa-circle",
                permanent: false,
                placement: "actionbar",
                name: "GDPRSectionBtn"
            });
        }
    }

    private openVCardGenerator(entityId = null) {
        if (entityId == null) return;

        //let vtContactAddresses: AddressEntityTypes.VCardAddressSelectListEntry[] = [];
        //vtContactAddresses.push({
        //    ID: this.entityId,
        //    label: `${this.entity.gDisp_1}`
        //})

        //if (this.entity.Classname == "persons") {
        //    this.formData.contactPerson?.forEach(cp => {
        //        vtContactAddresses.push({
        //            ID: cp.entity.ID,
        //            label: `${cp.contactPersonType} - ${cp.jobTitle.value}`,
        //            organizationName: cp.organisation.value
        //        })
        //    });
        //}

        let vCardGen = new VCardGenerator(entityId);
    }

    private checkSectionContents(): void {
        //console.debug("checkSectionContents", this.formData);


        this.AddressCategoryDataForm.expander.setMarking(this.store_AddressCategories.getCurrentCompleteList().length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
        this.ContactPersonDataForm.expander.setMarking(this.formData.contactPerson?.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
        this.OrganizationContactPersonDataForm.expander.setMarking(this.formData.orgContactPersons?.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
        this.FinanceDataForm.expander.setMarking(
            this.vatNr.getValue() ||
                this.taxNr.getValue() ||
                this.formData.bankAccount?.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
        this.ComposerDataForm.expander.setMarking(this.composerBirthDate.getValue() || this.composerBirthDate_Date.getValue() || this.composerDiedDate.getValue() || this.composerDiedDate_Date.getValue() ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
        if (!FeatureHelpers.hasModuleVersion("Address", 251201.0000)) this.PerformerDataForm.expander.setMarking(this.formData.performer?.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);

        this.FileDataForm.expander.setMarking(this.filesTable?.childElementCount ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);

        this.sectionTelecom.expander.setMarking(this.contactAndCommunicationTable.hasEntries() ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
    }

    private _loadFileCategoriesList(): void {

        let requestUrl = window.appRoot + "AddressWizard/GetFileCategoriesList";

        this.RequestManager.post(
            requestUrl,
            {
                jsonData: null
            },
            (response: any) => { this.fileCategories = response },
            (err: any) => { alert(err.Message) },
            false // sync
        );
    }

    private setUpDivisionsSection(): void {
        if (!this.hasFeature("Address/DivisionsSection")) return;

        this.UiModder.domClass.remove(this.divisionsSectionContainer.domNode, "w3-hide");

        if (this.divisionsSection != null) this.divisionsSection.destroy();
        //debugger;
        if (!this.entity && !this.hasFeature("Address/DivisionsSection", null, 2412090000)) {
            this.UiModder.domClass.add(this.divisionsSectionContainer.domNode, "w3-disabled");
            return;
        } else {
            this.UiModder.domClass.remove(this.divisionsSectionContainer.domNode, "w3-disabled");
        }
        this.divisionsSection = new DivisionsSection(this.entity?.ID);

        this.divisionsSectionContainer.setContent(this.divisionsSection);
        this.divisionsSection.on("SetupDivisionsList", (isSth: boolean) => {

            this.divisionsSectionContainer.setMarking(isSth ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
        });

        if (this.hasFeature("Address/DivisionsSection", null, 2412090000)) {
            this.divisionsSection.on("change", lang.hitch(this, this._onChangeDivisions));
        }
    }

    private _onChangeDivisions(data) {

        if (!this.hasFeature("Address/DivisionsSection", null, 2412090000)) return;


    }

    private setupExtendedPropertySection(list: Array<ExtendedProperties.PropertyAssignment<AddressWizardTypes.AddressEntity>>): void {
        if (this.hasFeature("Address/ExtendedPropertyList")) {

            this.hideNode(this.extendedPropertySectionContainer, false);
            this.requestContextButtonDisable("extendedPropertyList", true);

            if (this.extendedPropertyList != null) this.extendedPropertyList.destroy();


            this.extendedPropertyList = new ExtendedPropertyList();

            this.extendedPropertySection.setContent(this.extendedPropertyList);

            this.extendedPropertyList.setup(AddressClassnames.vt_addresses, this.entity, list);
            this.extendedPropertyList.on("change", lang.hitch(this, this._onChangeExtendedProperties));


            this.extendedPropertySection.setMarking(list?.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
        }

        if (this.hasFeature("Address/ExtendedPropertyListOM")) {
            // TODO
            // eventuell besser: nicht zwei Expander machen, sondern EINEN Expander und darin mit Pagestack "normal" und "OM" als Pages
        }


    }

    private _onChangeExtendedProperties() {
        let list = this.extendedPropertyList.getData();

        this.extendedPropertySection.setMarking(list?.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);

        //this.entity.extendedPropertyAssignments = list;
        this.formData.personExtendedProperties = this.extendedPropertyList.getDiffData();

        this.setDirty(true);
    }

    private _openNewAddress(entity: AddressEntityTypes.ContactPersonEntity): void {

        let editor = new AddressWizard();
        editor.startup();

        if (this.isEmbeddedInTab) { // braucht noch prüfung stäter!

            this.closeTab();
            this.requestNewTabbedContent({
                enableClosing: true,
                name: entity.ref_person.ID,
                sidebarEntryName: entity.ref_person.ID,
                label: this.title,
                widget: editor,
                groupLabel: entity.ref_person.gDisp_1,
                targetContainerName: this.getContainerName()
            }, true);
        } else {

            let dlg = new GenericDialog();
            dlg.closeOnEnter = false;
            dlg.closeOnEscape = false;
            dlg._setTopCloseBtnAttr(true);
            dlg.keepOpen = true;

            dlg.show(editor,
                entity.ref_person.gDisp_1,
                null,
                null,
                "saveclose",
                lang.hitch(this, this._confirmNewAddressCallback, dlg, editor));
        }

        editor.setup(entity.ref_person.ID);
        //his.editor.on("saved", lang.hitch(this, this.onEntityChange));
    }
    private _confirmNewAddressCallback(dlg: MdsLax<InstanceType<typeof GenericDialog>>, form: AddressWizard, result) {
        if (result <= 0) {
            dlg.close(-1, true);
        } else {
            form.submitFormData();
        }
    }

    private _startupSteps: Array<string> = null;
    private _startupStepsFinished: Array<string> = null;
    private _startupCompleteTimeout: any = null;

    private addStartupStep(stepname: string) {
        if (!stepname) return;

        if (this._startupSteps == null) {
            this._startupSteps = [];
            this._startupStepsFinished = [];
        }

        let index = this._startupSteps.indexOf(stepname);
        if (index == -1) {
            if (this._startupCompleteTimeout != null) {
                clearTimeout(this._startupCompleteTimeout);
                this._startupCompleteTimeout = null;
            }

            this._startupSteps.push(stepname);
            this._isDataLoading = true;
        }

    }

    private completeStartupStep(stepname: string) {
        if (!stepname) return;
        if (!lang.isArray(this._startupStepsFinished)) this._startupStepsFinished = [];

        let index = this._startupSteps.indexOf(stepname);
        if (index == -1) return;

        if (this._startupCompleteTimeout != null) {
            clearTimeout(this._startupCompleteTimeout);
            this._startupCompleteTimeout = null;
        }


        this._startupStepsFinished.push(stepname);

        //console.debug(this.id + " startupstep finished:", stepname, this._startupSteps, this._startupStepsFinished);

        for (let step of this._startupSteps) {
            let completedIndex = this._startupStepsFinished.indexOf(step);
            if (completedIndex == -1) return;
        }

        this._startupCompleteTimeout = setTimeout(lang.hitch(this, this._onStartupStepsCompleted));
    }

    private _onStartupStepsCompleted() {

        //console.debug(this.id + " startup completed", this._startupSteps, this._startupStepsFinished);

        this._startupSteps = null;
        this._startupStepsFinished = null;

        this._isDataLoading = false;
        setTimeout(lang.hitch(this, this.setDirty, false), 444); // des is natürlich deppert, weil magic number
    }

    private _loadAddressDocumentsSection() {

        if (this.selectedAddressType === "person" && this.hasUserRole("Address_AddressDocuments_Main")) {
            this.hideNode(this.sectionAddressDocuments.expander.domNode.parentNode, false);

            this.requestContextButtonEnable("addressDocumentsBtn");

            if (this.addressDocumentsWidget) {
                this.addressDocumentsWidget.destroy();
                this.addressDocumentsChangedData = null;
            }

            this.addressDocumentsWidget = new AddressDocumentsMain(this.entityId, this.entity?.gDisp_Firstname_Name);
            this.addressDocumentsWidget.placeAt(this.addressDocumentsWidgetContainer);
            this.addressDocumentsWidget.on("AddressDocuments_TableUpdate", (hasContent) => {
                this.sectionAddressDocuments.expander.setMarking(hasContent ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
            })
            this.addressDocumentsWidget.on("AddressDocument_DataChanged", (data) => {
                this.addressDocumentsChangedData = data;
                this.formData.addressDocumentsData = this.addressDocumentsChangedData;
                if (this.addressDocumentsChangedData) this.setDirty(true);
            });
        }
        else {
            this.hideNode(this.sectionAddressDocuments);
            this.requestContextButtonDisable("addressDocumentsBtn");
        }
    }
    private _loadFurtherAddressesSection() {

        if (this.hasUserRole("AddressWizard_FurtherAddressesData")) {
            this.hideNode(this.sectionFurtherAddresses.expander.domNode.parentNode, false);

            this.requestContextButtonEnable("furtherAddressesBtn");

            if (this.furtherAddressesWidget) {
                this.furtherAddressesWidget.destroy();
                this.furtherAddressesChangedData = null;
            }

            this.furtherAddressesWidget = new FurtherAddressesMain(this.entityId);
            this.furtherAddressesWidget.placeAt(this.furtherAddressesWidgetContainer);
            this.furtherAddressesWidget.on("FurtherAddresses_TableUpdate", (hasContent) => {
                this.sectionFurtherAddresses.expander.setMarking(hasContent ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
            })
            this.furtherAddressesWidget.on("FurtherAddresses_DataChanged", (data) => {
                this.furtherAddressesChangedData = data;
                this.formData.furtherAddressesData = this.furtherAddressesChangedData;
                if (this.furtherAddressesChangedData) this.setDirty(true);
            });
        }
        else {

            this.hideNode(this.sectionFurtherAddresses);
            this.requestContextButtonDisable("furtherAddressesBtn");
        }
    }

    private _loadCommunicationPanelSection() {
        //if (this.selectedAddressType == "person") return;

        if (!this.entityId) return;

        if (this.hasFeature("Address/CommunicationPanel")) {
            this.hideNode(this.communicationPanelContainer, false);

            if (this.communicationPanel) {
                this.communicationPanel.destroy();
            }

            this.communicationPanel = new CommunicationPanel(this.selectedAddressType, this.entityId);
            this.communicationPanel.placeAt(this.communicationPanelWidgetContainer);

            this.communicationPanel.on("hasContent", (obj: { hasContent: boolean }) => {

                this.communicationPanelExpander.setMarking(obj.hasContent ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
            })
        }
    }
    private _loadPerformerSection(): void {
        if (!FeatureHelpers.hasModuleVersion("Address", 251201.0000)) {
            this.hideNode(this.performerSectionContainer);
            this.requestContextButtonDisable("performerSectionBtn");
        }
        this.hideNode(this.performerSectionContainer, false);
        this.hideNode(this.PerformerDataForm); // old Section

        this.requestContextButtonEnable("performerSectionBtn");

        if (this.performerSection) {
            this.performerSection.destroy();
            this.performerSectionChangedData = null;
        }

        this.performerSection = new PerformerSection(this.selectedAddressType, this.entityId);

        this.performerSectionContainer.setContent(this.performerSection);

        this.performerSection.on("DataUpdate", (hasContent) => {
            this.performerSectionContainer.setMarking(hasContent ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
        })
        this.performerSection.on("DataChanged", (data) => {
            this.performerSectionChangedData = data;
            this.formData.performerSectionData = this.performerSectionChangedData;
            if (this.performerSectionChangedData) this.setDirty(true);
        });
    }
    private _loadGDPRSection() {

        if (this.selectedAddressType === "person" && this.hasUserRole("Addresses_GDPR")) {
            this.hideNode(this.GDPRSectionExpander.expander.domNode.parentNode, false);

            this.requestContextButtonEnable("GDPRSectionBtn");

            if (this.GDPRSectionWidget) {
                this.GDPRSectionWidget.destroy();
                this.GDPRSectionChangedData = null;
            }

            this.GDPRSectionWidget = new GDPRSection(this.entityId);
            this.GDPRSectionWidget.placeAt(this.GDPRSectionWidgetContainer);
            this.GDPRSectionWidget.on("GDPR_TableUpdate", (hasContent) => {
                this.GDPRSectionExpander.expander.setMarking(hasContent ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
            })
            this.GDPRSectionWidget.on("GDPR_DataChanged", (data) => {
                this.GDPRSectionChangedData = data;
                this.formData.GDPRData = this.GDPRSectionChangedData;
                if (this.GDPRSectionChangedData) this.setDirty(true);
            });
        }
        else {

            this.hideNode(this.GDPRSectionExpander);
            this.requestContextButtonDisable("GDPRSectionBtn");
        }
    }

    setOverrideSectionVisibilityConfig(config: Types.HideSelectedSectionsConfig) {

        this.overrideSectionVisibilityConfig = config;
    }
    applyOverrideSectionVisibility() {

        let nodesToHide = [];
        for (const [key, value] of Object.entries(this.overrideSectionVisibilityConfig)) {

            switch (key) {
                case "base":
                    if (value === true) {
                        nodesToHide.push(this.GeneralCompanyDataForm);
                        nodesToHide.push(this.GeneralPersonDataForm);
                    }
                    break;
                case "telecom":
                    if (value === true) nodesToHide.push(this.sectionTelecom.expander);
                    break;
                case "communicationPanel":
                    if (value === true) nodesToHide.push(this.communicationPanelContainer);
                    break;
                case "divisions":
                    if (value === true) nodesToHide.push(this.divisionsSectionContainer);
                    break;
                case "organizationContactPerson":
                    if (value === true) nodesToHide.push(this.OrganizationContactPersonDataForm.expander);
                    break;
                case "addressCategory":
                    if (value === true) nodesToHide.push(this.AddressCategoryDataForm.expander);
                    break;
                case "financeData":
                    if (value === true) nodesToHide.push(this.FinanceDataForm.expander);
                    break;
                case "addressDocuments":
                    if (value === true) nodesToHide.push(this.sectionAddressDocuments.expander);
                    break;
                case "furtherAddresses":
                    if (value === true) nodesToHide.push(this.sectionFurtherAddresses.expander);
                    break;
                case "contactPersonData":
                    if (value === true) nodesToHide.push(this.ContactPersonDataForm.expander);
                    break;
                case "performer":
                    if (value === true) {
                        nodesToHide.push(this.performerSectionContainer);
                        nodesToHide.push(this.PerformerDataForm.expander);
                    }
                    break;
                case "composer":
                    if (value === true) nodesToHide.push(this.ComposerDataForm.expander);
                    break;
                case "extendedProperty":
                    if (value === true) nodesToHide.push(this.extendedPropertySectionContainer);
                    break;
                case "todoAppointments":
                    if (value === true) nodesToHide.push(this.sectionTodoAppointments);
                    break;
                case "relatedAddresses":
                    if (value === true) nodesToHide.push(this.sectionRelatedAddresses);
                    break;
                case "file":
                    if (value === true) nodesToHide.push(this.FileDataForm.expander);
                    break;
                case "GDPR":
                    if (value === true) nodesToHide.push(this.GDPRSectionExpander.expander);
                    break;
            }
        }

        nodesToHide.forEach(n => {
            this.hideNode(n, true);
        })
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.useStandbyManager = true;

        if (!this.hasFeature("Address/Classlevel")) {
            this.hideNode(this.sectionClasslevel, true);
            this.hideNode(this.SearchSelect_classlevel, true);
            this.hideNode(this.classlevel, true);

            this.UiModder.domConstruct.destroy(this.sectionClasslevel);
            this.UiModder.domConstruct.destroy(this.SearchSelect_classlevel);
        } else {
            this.classlevel.setCallfunction("Webtool_API_AddressWizard__HintBox_GetClasslevelList");
        }

        ExtraHelpers.sideLoadResource(
                    window.appRoot + "Content/intertelinput/intlTelInput.js", 'js'
        ).then(()=>{
            let defaults:Array<string> = window.intlTelInputGlobals.defaults.preferredCountries;
            for (let d of defaults){
                this.preferredCountries.unshift(d);
            }
            this.postCreate_continue();
        });

        this.on("change_selectedAddressType", lang.hitch(this, this._onChange_selectedAddressType))
        this.profession.on("change", lang.hitch(this, this._onProfessionChange));
        this.addPerformerBtnContainer.title = this.translate("AddressWizard__addProfession_btnHint");

        if (this.hasUserRole("Addresses_Finance_Edit") != true) {
            this.addBankAccountButton.disabled = true;
            this.addBankAccountButton.classList.add("disabled");
            this.iban.setReadonly(true);
            this.inputBank.setReadonly(true);
        } else {
            this.addBankAccountButton.disabled = false;
            this.addBankAccountButton.classList.remove("disabled");
            this.iban.setReadonly(false);

            if (this.hasFeature("Address/BankRedEntry")) {
                this.inputBank.setReadonly(true);
                this.hideNode(this.Edit_Bank);
                this.hideNode(this.Edit_BankRed, false);
            } else {
                this.inputBank.setReadonly(false);
                this.bankNameRed.setReadonly(true);
                this.bankNumberRed.setReadonly(true);
            }
        }
    }

    private _onProfessionChange(){
        let shouldDisabled = this.profession?.getValue() == null;
        this.addPerformerBtn.disabled = shouldDisabled;
    }

    private postCreate_continue(){
        this.mainCityPerson.enablePlainTextValue = this.hasFeature("address/plaintextCities");
        this.mainPlzPerson.enablePlainTextValue = this.hasFeature("address/plaintextCities");
        this.mainCityCompany.enablePlainTextValue = this.hasFeature("address/plaintextCities");
        this.mainPlzCompany.enablePlainTextValue = this.hasFeature("address/plaintextCities");

        if (this.hasFeature("AddressWizard/orgaNoName2") === true) this.UiModder.domClass.add(this.Edit_name2, "w3-hide w3-disabled");
        if (this.hasFeature("AddressWizard/orgaNoName3") === true) this.UiModder.domClass.add(this.Edit_name3, "w3-hide w3-disabled");

        this.setupExpanders();

        this._loadFileCategoriesList();
        //topic.subscribe("FileUploadDisplay/NewRowCreated", lang.hitch(this, this.setupSelectBoxInFileRow));

        this.fileUpload.on("NewRowCreated", lang.hitch(this, this.setupSelectBoxInFileRow));



        this.AllCountriesData = window.intlTelInputGlobals.getCountryData();
        this.addPreferredCountries();
        this._getSelectboxData();
        this.activeCheckBox.setLabel(this.translate("AddressWizard__isActive"));
        //this.isComposerCheckBox.setLabel(this.translate("AddressWizard__isComposer"]);
        //this.isPerformerCheckBox.setLabel(this.translate("AddressWizard__isPerformer"]);
        //this.isContactPersonCheckBox.setLabel(this.translate("AddressWizard__isContactPerson"]);
        //this.isPerformerCheckBox2.setLabel(this.translate("AddressWizard__isPerformer"]);


        /*
        this.city.enablePlainTextValue = true;
        this.plz.enablePlainTextValue = true;
        this.mainProfession.enablePlainTextValue = true;
        */

        this.profession.isMandatory = true;
        this.profession.enablePlainTextValue = false;
        //this.profession.enableSelectEntityDialog(true);

        this.inputBank.isMandatory = true;
        this.inputBank.enablePlainTextValue = false;
        //this.addressCategory.isMandatory = true;

        this.store_AddressCategories = new EntityStore();
        this.store_AddressCategories.setup([]);
        this.store_AddressCategories.on("change", lang.hitch(this, this._onChange_AddressCategoryStore));
        this.addStartupStep("categories");
        this.addressCategory.loadListValues(null, true);
        this.addressCategory.on("loaded", lang.hitch(this, this._onLoaded_AddressCategories));
        //this.addressCategory.enablePlainTextValue = false;

        this.mainStreetPerson.setValidationEnabled(false);
        this.firstname.setValidationEnabled(false);
        this.name1.setValidationEnabled(false);
        this.name3.setValidationEnabled(false);
        this.name2.setValidationEnabled(false);
        this.note.setValidationEnabled(false);
        this.note2.setValidationEnabled(false);
        this.birthDate.setValidationEnabled(false);

        this.citizenship.enableSelectEntityDialog(true);

        this.addSubscription("AddressWizard/OpenNewAddress", lang.hitch(this, this._openNewAddress));
        this.contactAndCommunicationTable = new contactDisplayTable();
        this.contactAndCommunicationTable.placeAt(this.contactAndCommunicationWidgetContainer);
        this.contactAndCommunicationTable.on("contentChange", lang.hitch(this, this.checkSectionContents));
        this.contactAndCommunicationTable.on("dirty", lang.hitch(this, () => {
            this.setDirty(true);
        }));
        this.contactAndCommunicationTable.on("requestCommunicationEditor", lang.hitch(this, this._onRequest_CommunicationEditor));
        this.on("saved", lang.hitch(this, this._onSaved_UpdateContactCommunicationData));
        this.on("ready", lang.hitch(this, this._onLoad_SetContactTableContext));

        //zusaetzliche validierungs logik fuer user experience -> #28659
        //damit invalide daten z.b. angezeigt werden
        let invalidMsgCooldown = Date.now() - 1;
        const showInvalidDateMsg = (isValid:boolean)=>{
            let v = isValid ?? true;
            if (v == false && Date.now() > invalidMsgCooldown){
                this.showToast(this.getTranslation("AddressWizard__Warning_InvalidDateInput"), "fas fa-exclamation");
            invalidMsgCooldown = Date.now() + 35000; // 30 sec cooldown
            }
        }
        this.birthDate.setValidationEnabled(true);
        this.composerBirthDate_Date.setValidationEnabled(true);
        this.composerDiedDate_Date.setValidationEnabled(true);
        this.birthDate.on("valid", lang.hitch(this, showInvalidDateMsg));
        this.composerBirthDate_Date.on("valid", lang.hitch(this, showInvalidDateMsg));
        this.composerDiedDate_Date.on("valid", lang.hitch(this, showInvalidDateMsg));
        //action bar ausblenden bis entweder person oder firma ausgewaehlt wurde
        this._tabContainer?.toggleVisibilityForActionBar(false);
    }

    private _onRequest_CommunicationEditor(editorWidget:MdsLax<InstanceType<typeof communicationEditor>>){
        //let tabConf = editorWidget.getTabConfig();
        //tabConf.targetContainerName = this.getTabContainerName();
        //this.createNewTabbedContent(tabConf, true, false);
        editorWidget.init(this.getTabContainerName());
    }
    private _onSaved_UpdateContactCommunicationData(){
        this.contactAndCommunicationTable.updateData();
    }

    private flagContactCommunicationContextWasSet = false;
    private _onLoad_SetContactTableContext(){
        if (this.flagContactCommunicationContextWasSet == false){
            this.flagContactCommunicationContextWasSet = true;
            this.contactAndCommunicationTable.setAddressContext(this.entityId, this.entity?.ref_country);
        }
    }

    _onCloseRequest() {
        let hasChanged = this.isDirty();

        if (hasChanged) {

            let dlgConfirm = new GenericDialog();
            dlgConfirm.show(this.translate("General_AskSavePendingChanges"),
                this.translate("General_PendingChanges"),
                "",
                "",
                "yesno",
                lang.hitch(this, this._confirmCallback));

            return false;

        } else {
            return true;
        }
    }

    _confirmCallback(result) {
        if (result == -1) {
            this.closeTab();
        } else {
            if (this.submitFormData() == true) {
                on(this, "saveComplete", lang.hitch(this, this.closeTab));
            }
        }
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }

}

export default mdsWidget(AddressWizard);
